import { polka__stellazhi, stellazhi } from "./vars/prices/stellazhi";
import { ruchkaSyomnaya, stoli_podkatnie, zink_stoli_podkatnie } from "./vars/prices/stoli_podkatnie";
import {
    derzhatel_rulona__stoyka__1,
    derzhatel_rulona__stoyka__2,
    derzhatel_rulona__stoyka__3,
    derzhatel_rulona__stoyka__4,
    dop_polka_pfk,
    ogranichitel__stoyka__bok,
    ogranichitel__stoyka__zad,
    stoyki,
    zink__stoyka,
} from "./vars/prices/stoyki";
import { gazlift, glaydery__esd, koltso_opornoe, podlokotniki__esd, stulya } from "./vars/prices/stulya";
import { dop_polka__telezhka__1, dop_polka__telezhka__2, telezhki } from "./vars/prices/telezhki";
import { krishka_na_tumbu, podstavka_pmt, tumbi } from "./vars/prices/tumbi";
import {
    dop_pokritie_verstak,
    perfopanel_verstak,
    planka_dlya_lotkov_plv,
    verstak__vs__2_tumba,
    verstak__vs__tumba,
} from "./vars/prices/verstaki";
import { polka__wardrobes, wardrobes } from "./vars/prices/wardrobes";

// TABLES
const stol_basovii = {
    bazovii__1200x700: {
        name: 'Стол "Базовый (СП)", мм',
        title: 'Стол "Базовый (СП)"',
        price: 0,
        active: false,
        type: "1200x700",
        width: 1200,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    bazovii__1200x900: {
        name: 'Стол "Базовый (СП)", мм',
        title: 'Стол "Базовый (СП)"',
        price: 0,
        active: false,
        type: "1200x900",
        width: 1200,
        depth: 900,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    bazovii__1500x700: {
        name: 'Стол "Базовый (СП)", мм',
        title: 'Стол "Базовый (СП)"',
        price: 0,
        active: false,
        type: "1500x700",
        width: 1500,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    bazovii__1500x900: {
        name: 'Стол "Базовый (СП)", мм',
        title: 'Стол "Базовый (СП)"',
        price: 0,
        active: false,
        type: "1500x900",
        width: 1500,
        depth: 900,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    bazovii__1800x700: {
        name: 'Стол "Базовый (СП)", мм',
        title: 'Стол "Базовый (СП)"',
        price: 0,
        active: false,
        type: "1800x700",
        width: 1800,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    bazovii__1800x900: {
        name: 'Стол "Базовый (СП)", мм',
        title: 'Стол "Базовый (СП)"',
        price: 0,
        active: false,
        type: "1800x900",
        width: 1800,
        depth: 900,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    bazovii__2000x700: {
        name: 'Стол "Базовый (СП)", мм',
        title: 'Стол "Базовый (СП)"',
        price: 0,
        active: false,
        type: "2000x700",
        width: 2000,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    bazovii__2000x900: {
        name: 'Стол "Базовый (СП)", мм',
        title: 'Стол "Базовый (СП)"',
        price: 0,
        active: false,
        type: "2000x900",
        width: 2000,
        depth: 900,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
};
const stol_komfort = {
    komfort__1200x700: {
        name: 'Стол "Комфорт (СПП)", мм',
        title: 'Стол "Комфорт (СПП)"',
        price: 0,
        active: false,
        type: "1200x700",
        width: 1200,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    komfort__1200x900: {
        name: 'Стол "Комфорт (СПП)", мм',
        title: 'Стол "Комфорт (СПП)"',
        price: 0,
        active: false,
        type: "1200x900",
        width: 1200,
        depth: 900,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    komfort__1500x700: {
        name: 'Стол "Комфорт (СПП)", мм',
        title: 'Стол "Комфорт (СПП)"',
        price: 0,
        active: false,
        type: "1500x700",
        width: 1500,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    komfort__1500x900: {
        name: 'Стол "Комфорт (СПП)", мм',
        title: 'Стол "Комфорт (СПП)"',
        price: 0,
        active: false,
        type: "1500x900",
        width: 1500,
        depth: 900,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    komfort__1800x700: {
        name: 'Стол "Комфорт (СПП)", мм',
        title: 'Стол "Комфорт (СПП)"',
        price: 0,
        active: false,
        type: "1800x700",
        width: 1800,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    komfort__1800x900: {
        name: 'Стол "Комфорт (СПП)", мм',
        title: 'Стол "Комфорт (СПП)"',
        price: 0,
        active: false,
        type: "1800x900",
        width: 1800,
        depth: 900,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
};
const stol_spr = {
    spr__1200x700: {
        name: 'Стол "СПР", мм',
        title: 'Стол "СПР"',
        price: 0,
        active: false,
        type: "1200x700",
        width: 1200,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    spr__1200x900: {
        name: 'Стол "СПР", мм',
        title: 'Стол "СПР"',
        price: 0,
        active: false,
        type: "1200x900",
        width: 1200,
        depth: 900,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    spr__1500x700: {
        name: 'Стол "СПР", мм',
        title: 'Стол "СПР"',
        price: 0,
        active: false,
        type: "1500x700",
        width: 1500,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    spr__1500x900: {
        name: 'Стол "СПР", мм',
        title: 'Стол "СПР"',
        price: 0,
        active: false,
        type: "1500x900",
        width: 1500,
        depth: 900,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    spr__1800x700: {
        name: 'Стол "СПР", мм',
        title: 'Стол "СПР"',
        price: 0,
        active: false,
        type: "1800x700",
        width: 1800,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    spr__1800x900: {
        name: 'Стол "СПР", мм',
        title: 'Стол "СПР"',
        price: 0,
        active: false,
        type: "1800x900",
        width: 1800,
        depth: 900,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
};
const stol_spb = {
    spb__1200x500: {
        name: 'Стол "СПБ", мм',
        title: 'Стол "СПБ"',
        price: 0,
        active: false,
        type: "1200x500",
        width: 1200,
        depth: 500,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    spb__1200x700: {
        name: 'Стол "СПБ", мм',
        title: 'Стол "СПБ"',
        price: 0,
        active: false,
        type: "1200x700",
        width: 1200,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    spb__1200x900: {
        name: 'Стол "СПБ", мм',
        title: 'Стол "СПБ"',
        price: 0,
        active: false,
        type: "1200x900",
        width: 1200,
        depth: 900,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    spb__1500x500: {
        name: 'Стол "СПБ", мм',
        title: 'Стол "СПБ"',
        price: 0,
        active: false,
        type: "1500x500",
        width: 1500,
        depth: 500,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    spb__1500x700: {
        name: 'Стол "СПБ", мм',
        title: 'Стол "СПБ"',
        price: 0,
        active: false,
        type: "1500x700",
        width: 1500,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    spb__1500x900: {
        name: 'Стол "СПБ", мм',
        title: 'Стол "СПБ"',
        price: 0,
        active: false,
        type: "1500x900",
        width: 1500,
        depth: 900,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    spb__1800x500: {
        name: 'Стол "СПБ", мм',
        title: 'Стол "СПБ"',
        price: 0,
        active: false,
        type: "1800x500",
        width: 1800,
        depth: 500,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    spb__1800x700: {
        name: 'Стол "СПБ", мм',
        title: 'Стол "СПБ"',
        price: 0,
        active: false,
        type: "1800x700",
        width: 1800,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    spb__1800x900: {
        name: 'Стол "СПБ", мм',
        title: 'Стол "СПБ"',
        price: 0,
        active: false,
        type: "1800x900",
        width: 1800,
        depth: 900,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    spb__2000x700: {
        name: 'Стол "СПБ", мм',
        title: 'Стол "СПБ"',
        price: 0,
        active: false,
        type: "2000x700",
        width: 2000,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    spb__2000x900: {
        name: 'Стол "СПБ", мм',
        title: 'Стол "СПБ"',
        price: 0,
        active: false,
        type: "2000x900",
        width: 2000,
        depth: 900,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
};
const stol_ostrov = {
    ostrov__1200x700: {
        name: 'Стол "Остров", мм',
        title: 'Стол "Остров"',
        price: 0,
        active: false,
        type: "2 x (1200x700)",
        width: 1200,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    ostrov__1200x900: {
        name: 'Стол "Остров", мм',
        title: 'Стол "Остров"',
        price: 0,
        active: false,
        type: "2 x (1200x900)",
        width: 1200,
        depth: 900,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    ostrov__1500x700: {
        name: 'Стол "Остров", мм',
        title: 'Стол "Остров"',
        price: 0,
        active: false,
        type: "2 x (1500x700)",
        width: 1500,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    ostrov__1500x900: {
        name: 'Стол "Остров", мм',
        title: 'Стол "Остров"',
        price: 0,
        active: false,
        type: "2 x (1500x900)",
        width: 1500,
        depth: 900,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    ostrov__1800x700: {
        name: 'Стол "Остров", мм',
        title: 'Стол "Остров"',
        price: 0,
        active: false,
        type: "2 x (1800x700)",
        width: 1800,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    ostrov__1800x900: {
        name: 'Стол "Остров", мм',
        title: 'Стол "Остров"',
        price: 0,
        active: false,
        type: "2 x (1800x900)",
        width: 1800,
        depth: 900,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
};
const stol_verstak_tumba = {
    verstak_1200_t1: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1200x700, t1",
        width: 1200,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1200_t2: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1200x700, t2",
        width: 1200,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1200_t3: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1200x700, t3",
        width: 1200,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1200_t5: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1200x700, t5",
        width: 1200,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1500_t1: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1500x700, t1",
        width: 1500,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1500_t2: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1500x700, t2",
        width: 1500,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1500_t3: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1500x700, t3",
        width: 1500,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1500_t5: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1500x700, t5",
        width: 1500,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1800_t1: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1800x700, t1",
        width: 1800,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1800_t2: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1800x700, t2",
        width: 1800,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1800_t3: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1800x700, t3",
        width: 1800,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1800_t5: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1800x700, t5",
        width: 1800,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
};
const stol_verstak_2_tumba = {
    verstak_1500_t1_t1: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1500x700, t1 t1",
        width: 1500,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1500_t1_t2: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1500x700, t1 t2",
        width: 1500,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1500_t1_t3: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1500x700, t1 t3",
        width: 1500,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1500_t1_t5: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1500x700, t1 t5",
        width: 1500,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1500_t2_t2: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1500x700, t2 t2",
        width: 1500,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1500_t2_t3: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1500x700, t2 t3",
        width: 1500,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1500_t2_t5: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1500x700, t2 t5",
        width: 1500,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1500_t3_t3: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1500x700, t3 t3",
        width: 1500,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1500_t3_t5: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1500x700, t3 t5",
        width: 1500,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1500_t5_t5: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1500x700, t5 t5",
        width: 1500,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1800_t1_t1: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1800x700, t1 t1",
        width: 1800,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1800_t1_t2: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1800x700, t1 t2",
        width: 1800,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1800_t1_t3: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1800x700, t1 t3",
        width: 1800,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1800_t1_t5: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1800x700, t1 t5",
        width: 1800,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1800_t2_t2: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1800x700, t2 t2",
        width: 1800,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1800_t2_t3: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1800x700, t2 t3",
        width: 1800,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1800_t2_t5: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1800x700, t2 t5",
        width: 1800,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1800_t3_t3: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1800x700, t3 t3",
        width: 1800,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1800_t3_t5: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1800x700, t3 t5",
        width: 1800,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak_1800_t5_t5: {
        name: 'Стол "Верстак", мм',
        title: 'Стол "Верстак"',
        price: 0,
        active: false,
        type: "1800x700, t5 t5",
        width: 1800,
        depth: 700,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
};
const stol_upakovochnii = {
    upakovochnii__1200x700: {
        name: 'Стол "Упаковочный", мм',
        title: 'Стол "Упаковочный"',
        price: 0,
        active: false,
        type: "1200x700",
        width: 1200,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    upakovochnii__1200x900: {
        name: 'Стол "Упаковочный", мм',
        title: 'Стол "Упаковочный"',
        price: 0,
        active: false,
        type: "1200x900",
        width: 1200,
        depth: 900,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    upakovochnii__1500x700: {
        name: 'Стол "Упаковочный", мм',
        title: 'Стол "Упаковочный"',
        price: 0,
        active: false,
        type: "1500x700",
        width: 1200,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    upakovochnii__1500x900: {
        name: 'Стол "Упаковочный", мм',
        title: 'Стол "Упаковочный"',
        price: 0,
        active: false,
        type: "1500x900",
        width: 1500,
        depth: 900,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    upakovochnii__1800x700: {
        name: 'Стол "Упаковочный", мм',
        title: 'Стол "Упаковочный"',
        price: 0,
        active: false,
        type: "1800x700",
        width: 1800,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    upakovochnii__1800x900: {
        name: 'Стол "Упаковочный", мм',
        title: 'Стол "Упаковочный"',
        price: 0,
        active: false,
        type: "1800x900",
        width: 1800,
        depth: 900,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    upakovochnii__2000x700: {
        name: 'Стол "Упаковочный", мм',
        title: 'Стол "Упаковочный"',
        price: 0,
        active: false,
        type: "2000x700",
        width: 2000,
        depth: 700,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    upakovochnii__2000x900: {
        name: 'Стол "Упаковочный", мм',
        title: 'Стол "Упаковочный"',
        price: 0,
        active: false,
        type: "2000x900",
        width: 2000,
        depth: 900,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
};
const stol_ksm = {
    ksm__1000x600: {
        name: "Комплект стола монтажника, мм",
        title: "Комплект стола монтажника",
        price: 0,
        active: false,
        type: "1000x600",
        width: 1000,
        depth: 600,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    ksm__1200x600: {
        name: "Комплект стола монтажника, мм",
        title: "Комплект стола монтажника",
        price: 0,
        active: false,
        type: "1200x600",
        width: 1200,
        depth: 600,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    ksm__1500x600: {
        name: "Комплект стола монтажника, мм",
        title: "Комплект стола монтажника",
        price: 0,
        active: false,
        type: "1500x600",
        width: 1500,
        depth: 600,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    ksm__1800x600: {
        name: "Комплект стола монтажника, мм",
        title: "Комплект стола монтажника",
        price: 0,
        active: false,
        type: "1800x600",
        width: 1800,
        depth: 600,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
};
const stol_raskroinii = {
    raskroinii__1200x1500: {
        name: 'Стол "Раскройный", мм',
        title: 'Стол "Раскройный"',
        price: 0,
        active: false,
        width: 1200,
        depth: 1500,
        type: "1200x1500",
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    raskroinii__1500x1500: {
        name: 'Стол "Раскройный", мм',
        title: 'Стол "Раскройный"',
        price: 0,
        active: false,
        width: 1500,
        depth: 1500,
        type: "1500x1500",
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    raskroinii__1800x1500: {
        name: 'Стол "Раскройный", мм',
        title: 'Стол "Раскройный"',
        price: 0,
        active: false,
        width: 1800,
        depth: 1500,
        type: "1800x1500",
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    raskroinii__2000x1500: {
        name: 'Стол "Раскройный", мм',
        title: 'Стол "Раскройный"',
        price: 0,
        active: false,
        width: 2000,
        depth: 1500,
        type: "2000x1500",
        piece: 0,
        price_esd: 0,
        position: "table",
    },
};
const stol_ssu = {
    ssu__1050x700: {
        name: 'Стол "ССУ", мм',
        title: 'Стол "ССУ"',
        price: 0,
        active: false,
        width: 1050,
        depth: 700,
        type: "1050x700",
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    ssu__1250x900: {
        name: 'Стол "ССУ", мм',
        title: 'Стол "ССУ"',
        price: 0,
        active: false,
        width: 1250,
        depth: 900,
        type: "1250x900",
        piece: 0,
        price_esd: 0,
        position: "table",
    },
};
const stol_smk = {
    smk__700x700: {
        name: 'Стол "СМК", мм',
        title: 'Стол "СМК"',
        price: 0,
        active: false,
        width: 700,
        depth: 700,
        type: "700x700",
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    smk__900x700: {
        name: 'Стол "СМК", мм',
        title: 'Стол "СМК"',
        price: 0,
        active: false,
        width: 900,
        depth: 700,
        type: "900x700",
        piece: 0,
        price_esd: 0,
        position: "table",
    },
};
// END TABLES

const elements = {
    width: {
        name: "Ширина, мм",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: null,
    },
    depth: {
        name: "Глубина, мм",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: null,
    },
    isEsdPrice: false,

    komplekt_stoek: {
        name: "Комплект задних стоек, шт",
        price: 0,
        active: false,
        type: "1",
        piece: 0,
        price_esd: 0,
        position: "up",
    },

    komplekt_stoek_kst: {
        name: "Комплект задних стоек КСТ, шт",
        price: 0,
        active: false,
        type: "1",
        piece: 0,
        price_esd: 0,
        position: "up",
    },

    komplekt_stoek_sr: {
        name: "Комплект задних стоек СР, шт",
        price: 0,
        active: false,
        type: "1",
        piece: 0,
        price_esd: 0,
        position: "up",
    },
};
const rama_razdelitelnaya = {
    rama_razdelitelnaya__1200: {
        name: "Рама разделительная, мм",
        price: 0,
        active: false,
        type: "1200",
        piece: 0,
        price_esd: 0,
        position: "up",
    },
    rama_razdelitelnaya__1500: {
        name: "Рама разделительная, мм",
        price: 0,
        active: false,
        type: "1500",
        piece: 0,
        price_esd: 0,
        position: "up",
    },
    rama_razdelitelnaya__1800: {
        name: "Рама разделительная, мм",
        price: 0,
        active: false,
        type: "1800",
        piece: 0,
        price_esd: 0,
        position: "up",
    },
    rama_razdelitelnaya__2000: {
        name: "Рама разделительная, мм",
        price: 0,
        active: false,
        type: "2000",
        piece: 0,
        price_esd: 0,
        position: "up",
    },
};
const polka_dlya_kantselyarskikh_prinadlezhnostei = {
    polka_dlya_kantselyarskikh_prinadlezhnostei: {
        name: "Полка для канцелярских принадлежностей, мм",
        price: 0,
        active: false,
        type: "300x100",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
};
const polka_vidvizhnaya_pod_orgtekhniku = {
    polka_vidvizhnaya_pod_orgtekhniku: {
        name: "Полка выдвижная под оргтехнику, мм",
        price: 0,
        active: false,
        type: "500х510х515",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
};
const konteiner_dlya_rabochikh_otkhodov = {
    konteiner_dlya_rabochikh_otkhodov: {
        name: "Контейнер для рабочих отходов, мм",
        price: 0,
        active: false,
        type: "500х510х515",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
};
const podstavka_pod_nogi = {
    podstavka_pod_nogi: {
        name: "Подставка под ноги, мм",
        price: 0,
        active: false,
        type: "400х300",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
};
const dop_pokritie = {
    zink__1200x500: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 1200x500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__1200x700: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 1200x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__1200x900: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 1200x900",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__1500x500: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 1500x500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__1500x700: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 1500x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__1500x900: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 1500x900",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__1800x700: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 1800x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__1800x900: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 1800x900",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__2000x700: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 2000x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__2000x900: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 2000x900",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polikarb__1000x800: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Поликарбон, 1000x800",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polikarb__1200x500: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Поликарбон, 1200x500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polikarb__1200x700: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Поликарбон, 1200x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polikarb__1200x800: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Поликарбон, 1200x800",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polikarb__1200x900: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Поликарбон, 1200x900",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polikarb__1500x500: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Поликарбон, 1500x500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polikarb__1500x700: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Поликарбон, 1500x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polikarb__1500x800: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Поликарбон, 1500x800",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polikarb__1500x900: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Поликарбон, 1500x900",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polikarb__1800x500: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Поликарбон, 1800x500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polikarb__1800x700: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Поликарбон, 1800x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polikarb__1800x800: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Поликарбон, 1800x800",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polikarb__1800x900: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Поликарбон, 1800x900",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polikarb__2000x700: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Поликарбон, 2000x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polikarb__2000x900: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Поликарбон, 2000x900",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const dop_pokritie__ostrov = {
    zink__ostrov__1200x700: {
        name: "Доп. покрытие столешницы островное",
        price: 0,
        active: false,
        type: "Оцинковка, 1200x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__ostrov__1200x900: {
        name: "Доп. покрытие столешницы островное",
        price: 0,
        active: false,
        type: "Оцинковка, 1200x900",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__ostrov__1500x700: {
        name: "Доп. покрытие столешницы островное",
        price: 0,
        active: false,
        type: "Оцинковка, 1500x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__ostrov__1500x900: {
        name: "Доп. покрытие столешницы островное",
        price: 0,
        active: false,
        type: "Оцинковка, 1500x900",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__ostrov__1800x700: {
        name: "Доп. покрытие столешницы островное",
        price: 0,
        active: false,
        type: "Оцинковка, 1800x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__ostrov__1800x900: {
        name: "Доп. покрытие столешницы островное",
        price: 0,
        active: false,
        type: "Оцинковка, 1800x900",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polikarb__ostrov__1200x700: {
        name: "Доп. покрытие столешницы островное",
        price: 0,
        active: false,
        type: "Поликарбон, 1200x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polikarb__ostrov__1200x900: {
        name: "Доп. покрытие столешницы островное",
        price: 0,
        active: false,
        type: "Поликарбон, 1200x900",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polikarb__ostrov__1500x700: {
        name: "Доп. покрытие столешницы островное",
        price: 0,
        active: false,
        type: "Поликарбон, 1500x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polikarb__ostrov__1500x900: {
        name: "Доп. покрытие столешницы островное",
        price: 0,
        active: false,
        type: "Поликарбон, 1500x900",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polikarb__ostrov__1800x700: {
        name: "Доп. покрытие столешницы островное",
        price: 0,
        active: false,
        type: "Поликарбон, 1800x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polikarb__ostrov__1800x900: {
        name: "Доп. покрытие столешницы островное",
        price: 0,
        active: false,
        type: "Поликарбон, 1800x900",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const corner_table = {
    corner_table__800: {
        name: "Угловой стол",
        price: 0,
        active: false,
        type: "800x500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    corner_table__1200: {
        name: "Угловой стол",
        price: 0,
        active: false,
        type: "1200x500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const acssesuari_dlya_tumbi = {
    box_carpet: {
        name: "Коврик для ящика тумбы, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        isMultyPieces: true,
        position: "down",
    },
    divider_set_up: {
        name: "Комплект перегородок для верхнего ящика КПВ, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        isMultyPieces: true,
        position: "down",
    },
    divider_set_a: {
        name: "Комплект перегородок для ящика тип-A, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        isMultyPieces: true,
        position: "down",
    },
    divider_set_b: {
        name: "Комплект перегородок для ящика тип-Б, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        isMultyPieces: true,
        position: "down",
    },
    divider_set_v: {
        name: "Комплект перегородок для ящика тип-В, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        isMultyPieces: true,
        position: "down",
    },
};
const tumba_podvesnaya_left = {
    tumba_podvesnaya__1__left: {
        name: "Тумба подвесная, к-во ящиков",
        price: 0,
        active: false,
        type: "1",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    tumba_podvesnaya__2_1__left: {
        name: "Тумба подвесная, к-во ящиков",
        price: 0,
        active: false,
        type: "2.1",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    tumba_podvesnaya__2_2__left: {
        name: "Тумба подвесная, к-во ящиков",
        price: 0,
        active: false,
        type: "2.2",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    tumba_podvesnaya__3__left: {
        name: "Тумба подвесная, к-во ящиков",
        price: 0,
        active: false,
        type: "3",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const tumba_podvesnaya_right = {
    tumba_podvesnaya__1__right: {
        name: "Тумба подвесная, к-во ящиков",
        price: 0,
        active: false,
        type: "1",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    tumba_podvesnaya__2_1__right: {
        name: "Тумба подвесная, к-во ящиков",
        price: 0,
        active: false,
        type: "2.1",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    tumba_podvesnaya__2_2__right: {
        name: "Тумба подвесная, к-во ящиков",
        price: 0,
        active: false,
        type: "2.2",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    tumba_podvesnaya__3__right: {
        name: "Тумба подвесная, к-во ящиков",
        price: 0,
        active: false,
        type: "3",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const annex_left_up = {
    bokovaya_pristavka__500__up__left: {
        name: "Приставка верхняя слева, мм",
        price: 0,
        active: false,
        type: "500x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    bokovaya_pristavka__600__up__left: {
        name: "Приставка верхняя слева, мм",
        price: 0,
        active: false,
        type: "600x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    bokovaya_pristavka__700__up__left: {
        name: "Приставка верхняя слева, мм",
        price: 0,
        active: false,
        type: "700x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    bokovaya_pristavka__900__up__left: {
        name: "Приставка верхняя слева, мм",
        price: 0,
        active: false,
        type: "900x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const annex_right_up = {
    bokovaya_pristavka__500__up__right: {
        name: "Приставка верхняя справа, мм",
        price: 0,
        active: false,
        type: "500x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    bokovaya_pristavka__600__up__right: {
        name: "Приставка верхняя справа, мм",
        price: 0,
        active: false,
        type: "600x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    bokovaya_pristavka__700__up__right: {
        name: "Приставка верхняя справа, мм",
        price: 0,
        active: false,
        type: "700x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    bokovaya_pristavka__900__up__right: {
        name: "Приставка верхняя справа, мм",
        price: 0,
        active: false,
        type: "900x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const annex_left_down = {
    bokovaya_pristavka__500__down__left: {
        name: "Приставка нижняя слева, мм",
        price: 0,
        active: false,
        type: "500x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    bokovaya_pristavka__600__down__left: {
        name: "Приставка нижняя слева, мм",
        price: 0,
        active: false,
        type: "600x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    bokovaya_pristavka__700__down__left: {
        name: "Приставка нижняя слева, мм",
        price: 0,
        active: false,
        type: "700x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    bokovaya_pristavka__900__down__left: {
        name: "Приставка нижняя слева, мм",
        price: 0,
        active: false,
        type: "900x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const annex_right_down = {
    bokovaya_pristavka__500__down__right: {
        name: "Приставка нижняя справа, мм",
        price: 0,
        active: false,
        type: "500x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    bokovaya_pristavka__600__down__right: {
        name: "Приставка нижняя справа, мм",
        price: 0,
        active: false,
        type: "600x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    bokovaya_pristavka__700__down__right: {
        name: "Приставка нижняя справа, мм",
        price: 0,
        active: false,
        type: "700x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    bokovaya_pristavka__900__down__right: {
        name: "Приставка нижняя справа, мм",
        price: 0,
        active: false,
        type: "900x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const table_stops_zadnii = {
    zadnii__700: {
        name: "Ограничитель стола задний, мм",
        price: 0,
        active: false,
        type: "700x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zadnii__900: {
        name: "Ограничитель стола задний, мм",
        price: 0,
        active: false,
        type: "900x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zadnii__1000: {
        name: "Ограничитель стола задний, мм",
        price: 0,
        active: false,
        type: "1000x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zadnii__1200: {
        name: "Ограничитель стола задний, мм",
        price: 0,
        active: false,
        type: "1200x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zadnii__1500: {
        name: "Ограничитель стола задний, мм",
        price: 0,
        active: false,
        type: "1500x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zadnii__1800: {
        name: "Ограничитель стола задний, мм",
        price: 0,
        active: false,
        type: "1800x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zadnii__2000: {
        name: "Ограничитель стола задний, мм",
        price: 0,
        active: false,
        type: "2000x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const table_stops_zadnii__ostrov = {
    zadnii__ostrov__1200: {
        name: "Ограничитель стола задний островной, мм",
        price: 0,
        active: false,
        type: "2 x (1200x60)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zadnii__ostrov__1500: {
        name: "Ограничитель стола задний островной, мм",
        price: 0,
        active: false,
        type: "2 x (1500x60)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zadnii__ostrov__1800: {
        name: "Ограничитель стола задний островной, мм",
        price: 0,
        active: false,
        type: "2 x (1800x60)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const table_stops_bokovoi = {
    bokovoi__400: {
        name: "Ограничитель стола боковой, мм",
        price: 0,
        active: false,
        type: "400x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    bokovoi__500: {
        name: "Ограничитель стола боковой, мм",
        price: 0,
        active: false,
        type: "500x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    bokovoi__600: {
        name: "Ограничитель стола боковой, мм",
        price: 0,
        active: false,
        type: "600x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    bokovoi__700: {
        name: "Ограничитель стола боковой, мм",
        price: 0,
        active: false,
        type: "700x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    bokovoi__900: {
        name: "Ограничитель стола боковой, мм",
        price: 0,
        active: false,
        type: "900x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const table_stops_bokovoi__ostrov = {
    bokovoi__ostrov__700: {
        name: "Ограничитель стола боковой островной, мм",
        price: 0,
        active: false,
        type: "2 x (700x60)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    bokovoi__ostrov__900: {
        name: "Ограничитель стола боковой островной, мм",
        price: 0,
        active: false,
        type: "2 x (900x60)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_nizhnyaya = {
    polka_nizhnyaya__dsp__1000x300: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1000x300",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__dsp__1000x400: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1000x400",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__dsp__1000x600: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1000x600",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__dsp__1000x800: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1000x800",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__dsp__1200x300: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1200x300",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__dsp__1200x400: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1200x400",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__dsp__1200x600: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1200x600",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__dsp__1200x800: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1200x800",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__dsp__1500x300: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1500x300",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__dsp__1500x400: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1500x400",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__dsp__1500x600: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1500x600",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__dsp__1500x800: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1500x800",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__dsp__1800x300: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1800x300",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__dsp__1800x400: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1800x400",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__dsp__1800x600: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1800x600",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__dsp__1800x800: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1800x800",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__dsp__2000x300: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "2000x300",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__dsp__2000x400: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "2000x400",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__dsp__2000x600: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "2000x600",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__dsp__2000x800: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "2000x800",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__metall__1000x400: {
        name: "Полка нижняя металл, мм",
        price: 0,
        active: false,
        type: "1000x400",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__metall__1200x400: {
        name: "Полка нижняя металл, мм",
        price: 0,
        active: false,
        type: "1200x400",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__metall__1200x500: {
        name: "Полка нижняя металл, мм",
        price: 0,
        active: false,
        type: "1200x500",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__metall__1500x400: {
        name: "Полка нижняя металл, мм",
        price: 0,
        active: false,
        type: "1500x400",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__metall__1500x500: {
        name: "Полка нижняя металл, мм",
        price: 0,
        active: false,
        type: "1500x500",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__metall__1800x400: {
        name: "Полка нижняя металл, мм",
        price: 0,
        active: false,
        type: "1800x400",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__metall__1800x500: {
        name: "Полка нижняя металл, мм",
        price: 0,
        active: false,
        type: "1800x500",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__metall__2000x400: {
        name: "Полка нижняя металл, мм",
        price: 0,
        active: false,
        type: "2000x400",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__metall__2000x500: {
        name: "Полка нижняя металл, мм",
        price: 0,
        active: false,
        type: "2000x500",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
};
const polka_nizhnyaya__ostrov = {
    polka_nizhnyaya__ostrov__1200x300: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1200x300",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__ostrov__1200x400: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1200x400",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__ostrov__1200x600: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1200x600",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__ostrov__1200x800: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1200x800",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__ostrov__1500x300: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1500x300",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__ostrov__1500x400: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1500x400",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__ostrov__1500x600: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1500x600",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__ostrov__1500x800: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1500x800",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__ostrov__1800x300: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1800x300",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__ostrov__1800x400: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1800x400",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__ostrov__1800x600: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1800x600",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
    polka_nizhnyaya__ostrov__1800x800: {
        name: "Полка нижняя ДСП, мм",
        price: 0,
        active: false,
        type: "1800x800",
        piece: 0,
        price_esd: 0,
        position: "down",
    },
};
const lotok_dlya_provodov = {
    lotok_dlya_provodov__1000: {
        name: "Лоток для проводов, мм",
        price: 0,
        active: false,
        type: "1000х85х75",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    lotok_dlya_provodov__1200: {
        name: "Лоток для проводов, мм",
        price: 0,
        active: false,
        type: "1200х85х75",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    lotok_dlya_provodov__1500: {
        name: "Лоток для проводов, мм",
        price: 0,
        active: false,
        type: "1500х85х75",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    lotok_dlya_provodov__1800: {
        name: "Лоток для проводов, мм",
        price: 0,
        active: false,
        type: "1800х85х75",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    lotok_dlya_provodov__2000: {
        name: "Лоток для проводов, мм",
        price: 0,
        active: false,
        type: "2000х85х75",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const podstavka_pod_sistemnii_blok = {
    podstavka_pod_sistemnii_blok__podvesnaya: {
        name: "Подставка под системный блок ",
        price: 0,
        active: false,
        type: "Подвесная",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    podstavka_pod_sistemnii_blok__podkatnaya: {
        name: "Подставка под системный блок ",
        price: 0,
        active: false,
        type: "Подкатная",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_dlya_klaviaturi = {
    polka_dlya_klaviaturi__metall: {
        name: "Полка для клавиатуры",
        price: 0,
        active: false,
        type: "Металл",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_dlya_klaviaturi__dsp: {
        name: "Полка для клавиатуры",
        price: 0,
        active: false,
        type: "ДСП",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_dlya_klaviaturi__plastik: {
        name: "Полка для клавиатуры",
        price: 0,
        active: false,
        type: "Пластик",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const razdeliteli = {
    razdeliteli_amount: {
        name: "Разделители на нижнюю полку (ШТУКИ), шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        isMultyPieces: true,
        position: "down",
    },
    razdeliteli_komplekt: {
        name: "Разделители на нижнюю полку (КОМПЛЕКТЫ), шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        isMultyPieces: true,
        position: "down",
    },
};
const razdeliteli_pribornaya = {
    razdeliteli_pribornaya_amount: {
        name: "Разделители на приборную полку (ШТУКИ), шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        isMultyPieces: true,
        position: "up",
    },
    razdeliteli_pribornaya_komplekt: {
        name: "Разделители на приборную полку (КОМПЛЕКТЫ), шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        isMultyPieces: true,
        position: "up",
    },
};
const yashchik_mk_plastik = {
    yashchik_mk_plastik: {
        name: "Ящик для мелких комплектующих, материал",
        price: 0,
        active: false,
        type: "Пластик",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const yashchik_mk_metall = {
    yashchik_mk_metall: {
        name: "Ящик для мелких комплектующих, материал",
        price: 0,
        active: false,
        type: "Металл",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const bokovie_fiksatori_rulona__nizhnii = {
    bokovie_fiksatori_rulona__nizhnii: {
        name: "Боковые фиксаторы рулона, шт.",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: null,
        isMultyPieces: true,
    },
};
const derzhatel_rulona__nizhnii = {
    derzhatel_rulona__nizhnii__1200: {
        name: "Держатель рулона нижний, мм",
        price: 0,
        active: false,
        type: "1200",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona__nizhnii__1500: {
        name: "Держатель рулона нижний, мм",
        price: 0,
        active: false,
        type: "1500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona__nizhnii__1800: {
        name: "Держатель рулона нижний, мм",
        price: 0,
        active: false,
        type: "1800",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona__nizhnii__2000: {
        name: "Держатель рулона нижний, мм",
        price: 0,
        active: false,
        type: "2000",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
// Верхние
const bokovie_fiksatori_rulona__verkhnii = {
    bokovie_fiksatori_rulona__verkhnii: {
        name: "Боковые фиксаторы рулона, шт.",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: null,
        isMultyPieces: true,
    },
};
const bokovie_fiksatori_rulona__full_width = {
    bokovie_fiksatori_rulona__full_width: {
        name: "Боковые фиксаторы рулона, шт.",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: null,
        isMultyPieces: true,
    },
};
const bokovie_fiksatori_rulona__half_width = {
    bokovie_fiksatori_rulona__half_width: {
        name: "Боковые фиксаторы рулона, шт.",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: null,
        isMultyPieces: true,
    },
};
const polka_pribornaya_dsp_1 = {
    polka_pribornaya_dsp_1200x300__1: {
        name: "Полка приборная ДСП, мм",
        price: 0,
        active: false,
        type: "1200x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_dsp_1500x300__1: {
        name: "Полка приборная ДСП, мм",
        price: 0,
        active: false,
        type: "1500x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_dsp_1800x300__1: {
        name: "Полка приборная ДСП, мм",
        price: 0,
        active: false,
        type: "1800x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_dsp_2000x300__1: {
        name: "Полка приборная ДСП, мм",
        price: 0,
        active: false,
        type: "2000x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_dsp_1200x400__1: {
        name: "Полка приборная ДСП, мм",
        price: 0,
        active: false,
        type: "1200x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_dsp_1500x400__1: {
        name: "Полка приборная ДСП, мм",
        price: 0,
        active: false,
        type: "1500x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_dsp_1800x400__1: {
        name: "Полка приборная ДСП, мм",
        price: 0,
        active: false,
        type: "1800x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_dsp_2000x400__1: {
        name: "Полка приборная ДСП, мм",
        price: 0,
        active: false,
        type: "2000x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_pribornaya_dsp_2 = {
    polka_pribornaya_dsp_1200x300__2: {
        name: "Полка приборная ДСП, мм",
        price: 0,
        active: false,
        type: "1200x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_dsp_1500x300__2: {
        name: "Полка приборная ДСП, мм",
        price: 0,
        active: false,
        type: "1500x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_dsp_1800x300__2: {
        name: "Полка приборная ДСП, мм",
        price: 0,
        active: false,
        type: "1800x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_dsp_2000x300__2: {
        name: "Полка приборная ДСП, мм",
        price: 0,
        active: false,
        type: "2000x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_dsp_1200x400__2: {
        name: "Полка приборная ДСП, мм",
        price: 0,
        active: false,
        type: "1200x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_dsp_1500x400__2: {
        name: "Полка приборная ДСП, мм",
        price: 0,
        active: false,
        type: "1500x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_dsp_1800x400__2: {
        name: "Полка приборная ДСП, мм",
        price: 0,
        active: false,
        type: "1800x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_dsp_2000x400__2: {
        name: "Полка приборная ДСП, мм",
        price: 0,
        active: false,
        type: "2000x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_pribornaya_dsp_3 = {
    polka_pribornaya_dsp_1200x300__3: {
        name: "Полка приборная ДСП, мм",
        price: 0,
        active: false,
        type: "1200x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_dsp_1500x300__3: {
        name: "Полка приборная ДСП, мм",
        price: 0,
        active: false,
        type: "1500x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_dsp_1800x300__3: {
        name: "Полка приборная ДСП, мм",
        price: 0,
        active: false,
        type: "1800x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_dsp_2000x300__3: {
        name: "Полка приборная ДСП, мм",
        price: 0,
        active: false,
        type: "2000x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_dsp_1200x400__3: {
        name: "Полка приборная ДСП, мм",
        price: 0,
        active: false,
        type: "1200x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_dsp_1500x400__3: {
        name: "Полка приборная ДСП, мм",
        price: 0,
        active: false,
        type: "1500x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_dsp_1800x400__3: {
        name: "Полка приборная ДСП, мм",
        price: 0,
        active: false,
        type: "1800x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_dsp_2000x400__3: {
        name: "Полка приборная ДСП, мм",
        price: 0,
        active: false,
        type: "2000x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_pribornaya_ostrov_1 = {
    polka_pribornaya_ostrov_1200x300__1: {
        name: "Полка приборная островная, мм",
        price: 0,
        active: false,
        type: "2 x (1200x300)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ostrov_1500x300__1: {
        name: "Полка приборная островная, мм",
        price: 0,
        active: false,
        type: "2 x (1500x300)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ostrov_1800x300__1: {
        name: "Полка приборная островная, мм",
        price: 0,
        active: false,
        type: "2 x (1800x300)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ostrov_2000x300__1: {
        name: "Полка приборная островная, мм",
        price: 0,
        active: false,
        type: "2 x (2000x300)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ostrov_1200x400__1: {
        name: "Полка приборная островная, мм",
        price: 0,
        active: false,
        type: "2 x (1200x400)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ostrov_1500x400__1: {
        name: "Полка приборная островная, мм",
        price: 0,
        active: false,
        type: "2 x (1500x400)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ostrov_1800x400__1: {
        name: "Полка приборная островная, мм",
        price: 0,
        active: false,
        type: "2 x (1800x400)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ostrov_2000x400__1: {
        name: "Полка приборная островная, мм",
        price: 0,
        active: false,
        type: "2 x (2000x400)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_pribornaya_ostrov_2 = {
    polka_pribornaya_ostrov_1200x300__2: {
        name: "Полка приборная островная, мм",
        price: 0,
        active: false,
        type: "2 x (1200x300)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ostrov_1500x300__2: {
        name: "Полка приборная островная, мм",
        price: 0,
        active: false,
        type: "2 x (1500x300)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ostrov_1800x300__2: {
        name: "Полка приборная островная, мм",
        price: 0,
        active: false,
        type: "2 x (1800x300)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ostrov_2000x300__2: {
        name: "Полка приборная островная, мм",
        price: 0,
        active: false,
        type: "2 x (2000x300)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ostrov_1200x400__2: {
        name: "Полка приборная островная, мм",
        price: 0,
        active: false,
        type: "2 x (1200x400)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ostrov_1500x400__2: {
        name: "Полка приборная островная, мм",
        price: 0,
        active: false,
        type: "2 x (1500x400)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ostrov_1800x400__2: {
        name: "Полка приборная островная, мм",
        price: 0,
        active: false,
        type: "2 x (1800x400)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ostrov_2000x400__2: {
        name: "Полка приборная островная, мм",
        price: 0,
        active: false,
        type: "2 x (2000x400)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_pribornaya_ostrov_3 = {
    polka_pribornaya_ostrov_1200x300__3: {
        name: "Полка приборная островная, мм",
        price: 0,
        active: false,
        type: "2 x (1200x300)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ostrov_1500x300__3: {
        name: "Полка приборная островная, мм",
        price: 0,
        active: false,
        type: "2 x (1500x300)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ostrov_1800x300__3: {
        name: "Полка приборная островная, мм",
        price: 0,
        active: false,
        type: "2 x (1800x300)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ostrov_2000x300__3: {
        name: "Полка приборная островная, мм",
        price: 0,
        active: false,
        type: "2 x (2000x300)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ostrov_1200x400__3: {
        name: "Полка приборная островная, мм",
        price: 0,
        active: false,
        type: "2 x (1200x400)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ostrov_1500x400__3: {
        name: "Полка приборная островная, мм",
        price: 0,
        active: false,
        type: "2 x (1500x400)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ostrov_1800x400__3: {
        name: "Полка приборная островная, мм",
        price: 0,
        active: false,
        type: "2 x (1800x400)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ostrov_2000x400__3: {
        name: "Полка приборная островная, мм",
        price: 0,
        active: false,
        type: "2 x (2000x400)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_pribornaya_ogranichiteli_zad_1 = {
    polka_pribornaya_ogranichiteli_600__1: {
        name: "Задний ограничитель полки, мм",
        price: 0,
        active: false,
        type: "600x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_1200__1: {
        name: "Задний ограничитель полки, мм",
        price: 0,
        active: false,
        type: "1200x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_1500__1: {
        name: "Задний ограничитель полки, мм",
        price: 0,
        active: false,
        type: "1500x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_1800__1: {
        name: "Задний ограничитель полки, мм",
        price: 0,
        active: false,
        type: "1800x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_2000__1: {
        name: "Задний ограничитель полки, мм",
        price: 0,
        active: false,
        type: "2000x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_pribornaya_ogranichiteli_zad_2 = {
    polka_pribornaya_ogranichiteli_600__2: {
        name: "Задний ограничитель полки, мм",
        price: 0,
        active: false,
        type: "600x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_1200__2: {
        name: "Задний ограничитель полки, мм",
        price: 0,
        active: false,
        type: "1200x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_1500__2: {
        name: "Задний ограничитель полки, мм",
        price: 0,
        active: false,
        type: "1500x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_1800__2: {
        name: "Задний ограничитель полки, мм",
        price: 0,
        active: false,
        type: "1800x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_2000__2: {
        name: "Задний ограничитель полки, мм",
        price: 0,
        active: false,
        type: "2000x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_pribornaya_ogranichiteli_zad_3 = {
    polka_pribornaya_ogranichiteli_600__3: {
        name: "Задний ограничитель полки, мм",
        price: 0,
        active: false,
        type: "600x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_1200__3: {
        name: "Задний ограничитель полки, мм",
        price: 0,
        active: false,
        type: "1200x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_1500__3: {
        name: "Задний ограничитель полки, мм",
        price: 0,
        active: false,
        type: "1500x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_1800__3: {
        name: "Задний ограничитель полки, мм",
        price: 0,
        active: false,
        type: "1800x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_2000__3: {
        name: "Задний ограничитель полки, мм",
        price: 0,
        active: false,
        type: "2000x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_pribornaya_ogranichiteli_zad_4 = {
    polka_pribornaya_ogranichiteli_600__4: {
        name: "Задний ограничитель полки, мм",
        price: 0,
        active: false,
        type: "600x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_pribornaya_ogranichiteli_zad_5 = {
    polka_pribornaya_ogranichiteli_600__5: {
        name: "Задний ограничитель полки, мм",
        price: 0,
        active: false,
        type: "600x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_pribornaya_ogranichiteli_zad_ostrov_1 = {
    polka_pribornaya_ogranichiteli_ostrov_1200__1: {
        name: "Задний ограничитель островной полки, мм",
        price: 0,
        active: false,
        type: "2 x (1200x60)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_ostrov_1500__1: {
        name: "Задний ограничитель островной полки, мм",
        price: 0,
        active: false,
        type: "2 x (1500x60)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_ostrov_1800__1: {
        name: "Задний ограничитель островной полки, мм",
        price: 0,
        active: false,
        type: "2 x (1800x60)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_ostrov_2000__1: {
        name: "Задний ограничитель островной полки, мм",
        price: 0,
        active: false,
        type: "2 x (2000x60)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_pribornaya_ogranichiteli_zad_ostrov_2 = {
    polka_pribornaya_ogranichiteli_ostrov_1200__2: {
        name: "Задний ограничитель островной полки, мм",
        price: 0,
        active: false,
        type: "2 x (1200x60)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_ostrov_1500__2: {
        name: "Задний ограничитель островной полки, мм",
        price: 0,
        active: false,
        type: "2 x (1500x60)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_ostrov_1800__2: {
        name: "Задний ограничитель островной полки, мм",
        price: 0,
        active: false,
        type: "2 x (1800x60)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_ostrov_2000__2: {
        name: "Задний ограничитель островной полки, мм",
        price: 0,
        active: false,
        type: "2 x (2000x60)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_pribornaya_ogranichiteli_zad_ostrov_3 = {
    polka_pribornaya_ogranichiteli_ostrov_1200__3: {
        name: "Задний ограничитель островной полки, мм",
        price: 0,
        active: false,
        type: "2 x (1200x60)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_ostrov_1500__3: {
        name: "Задний ограничитель островной полки, мм",
        price: 0,
        active: false,
        type: "2 x (1500x60)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_ostrov_1800__3: {
        name: "Задний ограничитель островной полки, мм",
        price: 0,
        active: false,
        type: "2 x (1800x60)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_ostrov_2000__3: {
        name: "Задний ограничитель островной полки, мм",
        price: 0,
        active: false,
        type: "2 x (2000x60)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_pribornaya_ogranichiteli_bok_1 = {
    polka_pribornaya_ogranichiteli_300__1: {
        name: "Комплект боковых ограничителей полки, мм",
        price: 0,
        active: false,
        type: "300x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_400__1: {
        name: "Комплект боковых ограничителей полки, мм",
        price: 0,
        active: false,
        type: "400x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_pribornaya_ogranichiteli_bok_2 = {
    polka_pribornaya_ogranichiteli_300__2: {
        name: "Комплект боковых ограничителей полки, мм",
        price: 0,
        active: false,
        type: "300x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_400__2: {
        name: "Комплект боковых ограничителей полки, мм",
        price: 0,
        active: false,
        type: "400x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_pribornaya_ogranichiteli_bok_3 = {
    polka_pribornaya_ogranichiteli_300__3: {
        name: "Комплект боковых ограничителей полки, мм",
        price: 0,
        active: false,
        type: "300x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_400__3: {
        name: "Комплект боковых ограничителей полки, мм",
        price: 0,
        active: false,
        type: "400x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_pribornaya_ogranichiteli_bok_4 = {
    polka_pribornaya_ogranichiteli_300__4: {
        name: "Комплект боковых ограничителей полки, мм",
        price: 0,
        active: false,
        type: "300x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_400__4: {
        name: "Комплект боковых ограничителей полки, мм",
        price: 0,
        active: false,
        type: "400x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_pribornaya_ogranichiteli_bok_5 = {
    polka_pribornaya_ogranichiteli_300__5: {
        name: "Комплект боковых ограничителей полки, мм",
        price: 0,
        active: false,
        type: "300x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_400__5: {
        name: "Комплект боковых ограничителей полки, мм",
        price: 0,
        active: false,
        type: "400x60",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_pribornaya_ogranichiteli_bok_ostrov_1 = {
    polka_pribornaya_ogranichiteli_ostrov_300__1: {
        name: "Комплект боковых ограничителей островной полки, мм",
        price: 0,
        active: false,
        type: "2 x (300x60)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_ostrov_400__1: {
        name: "Комплект боковых ограничителей островной полки, мм",
        price: 0,
        active: false,
        type: "2 x (400x60)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_pribornaya_ogranichiteli_bok_ostrov_2 = {
    polka_pribornaya_ogranichiteli_ostrov_300__2: {
        name: "Комплект боковых ограничителей островной полки, мм",
        price: 0,
        active: false,
        type: "2 x (300x60)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_ostrov_400__2: {
        name: "Комплект боковых ограничителей островной полки, мм",
        price: 0,
        active: false,
        type: "2 x (400x60)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_pribornaya_ogranichiteli_bok_ostrov_3 = {
    polka_pribornaya_ogranichiteli_ostrov_300__3: {
        name: "Комплект боковых ограничителей островной полки, мм",
        price: 0,
        active: false,
        type: "2 x (300x60)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_ogranichiteli_ostrov_400__3: {
        name: "Комплект боковых ограничителей островной полки, мм",
        price: 0,
        active: false,
        type: "2 x (400x60)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_pribornaya_metall_1 = {
    polka_pribornaya_metall_1200__1: {
        name: "Полка приборная наклонная металл, мм",
        price: 0,
        active: false,
        type: "1200x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_metall_1500__1: {
        name: "Полка приборная наклонная металл, мм",
        price: 0,
        active: false,
        type: "1500x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_metall_1800__1: {
        name: "Полка приборная наклонная металл, мм",
        price: 0,
        active: false,
        type: "1800x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_metall_2000__1: {
        name: "Полка приборная наклонная металл, мм",
        price: 0,
        active: false,
        type: "2000x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_pribornaya_metall_2 = {
    polka_pribornaya_metall_1200__2: {
        name: "Полка приборная наклонная металл, мм",
        price: 0,
        active: false,
        type: "1200x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_metall_1500__2: {
        name: "Полка приборная наклонная металл, мм",
        price: 0,
        active: false,
        type: "1500x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_metall_1800__2: {
        name: "Полка приборная наклонная металл, мм",
        price: 0,
        active: false,
        type: "1800x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_metall_2000__2: {
        name: "Полка приборная наклонная металл, мм",
        price: 0,
        active: false,
        type: "2000x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_pribornaya_metall_3 = {
    polka_pribornaya_metall_1200__3: {
        name: "Полка приборная наклонная металл, мм",
        price: 0,
        active: false,
        type: "1200x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_metall_1500__3: {
        name: "Полка приборная наклонная металл, мм",
        price: 0,
        active: false,
        type: "1500x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_metall_1800__3: {
        name: "Полка приборная наклонная металл, мм",
        price: 0,
        active: false,
        type: "1800x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_pribornaya_metall_2000__3: {
        name: "Полка приборная наклонная металл, мм",
        price: 0,
        active: false,
        type: "2000x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const osveshchenie_verkhnee = {
    osveshchenie_verkhnee_pryamoi_1200: {
        name: "Освещение верхнее, тип",
        price: 0,
        active: false,
        type: "Прямой, 1200",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    osveshchenie_verkhnee_pryamoi_1500: {
        name: "Освещение верхнее, тип",
        price: 0,
        active: false,
        type: "Прямой, 1500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    osveshchenie_verkhnee_pryamoi_1800: {
        name: "Освещение верхнее, тип",
        price: 0,
        active: false,
        type: "Прямой, 1800",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    osveshchenie_verkhnee_pryamoi_2000: {
        name: "Освещение верхнее, тип",
        price: 0,
        active: false,
        type: "Прямой, 2000",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    osveshchenie_verkhnee_naklonnii_1200: {
        name: "Освещение верхнее, тип",
        price: 0,
        active: false,
        type: "Наклонный, 1200",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    osveshchenie_verkhnee_naklonnii_1500: {
        name: "Освещение верхнее, тип",
        price: 0,
        active: false,
        type: "Наклонный, 1500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    osveshchenie_verkhnee_naklonnii_1800: {
        name: "Освещение верхнее, тип",
        price: 0,
        active: false,
        type: "Наклонный, 1800",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    osveshchenie_verkhnee_naklonnii_2000: {
        name: "Освещение верхнее, тип",
        price: 0,
        active: false,
        type: "Наклонный, 2000",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const osveshchenie_verkhnee_ostrov = {
    osveshchenie_verkhnee_ostrov_1200: {
        name: "Освещение верхнее островное, мм",
        price: 0,
        active: false,
        type: "2 x 1200",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    osveshchenie_verkhnee_ostrov_1500: {
        name: "Освещение верхнее островное, мм",
        price: 0,
        active: false,
        type: "2 x 1500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    osveshchenie_verkhnee_ostrov_1800: {
        name: "Освещение верхнее островное, мм",
        price: 0,
        active: false,
        type: "2 x 1800",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const instrumentalnaya_planka = {
    instrumentalnaya_planka_1200: {
        name: "Планка для подвеса инструментов, мм",
        price: 0,
        active: false,
        type: "1200",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    instrumentalnaya_planka_1500: {
        name: "Планка для подвеса инструментов, мм",
        price: 0,
        active: false,
        type: "1500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    instrumentalnaya_planka_1800: {
        name: "Планка для подвеса инструментов, мм",
        price: 0,
        active: false,
        type: "1800",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    instrumentalnaya_planka_2000: {
        name: "Планка для подвеса инструментов, мм",
        price: 0,
        active: false,
        type: "2000",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const instrumentalnaya_planka_ostrov = {
    instrumentalnaya_planka_ostrov_1200: {
        name: "Планка для подвеса инструментов островная, мм",
        price: 0,
        active: false,
        type: "2 x 1200",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    instrumentalnaya_planka_ostrov_1500: {
        name: "Планка для подвеса инструментов островная, мм",
        price: 0,
        active: false,
        type: "2 x 1500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    instrumentalnaya_planka_ostrov_1800: {
        name: "Планка для подвеса инструментов островная, мм",
        price: 0,
        active: false,
        type: "2 x 1800",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const derzhatel_ruchnogo_instrumenta = {
    derzhatel_ruchnogo_instrumenta: {
        name: "Держатель ручного инструмента, шт.",
        price: 0,
        active: false,
        type: "1",
        piece: 0,
        price_esd: 0,
        position: "up",
    },
};
const osveshchenie_pod_pribornuyu = {
    osveshchenie_pod_pribornuyu_600: {
        name: "Освещение под приборную полку, мм",
        price: 0,
        active: false,
        type: "600",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    osveshchenie_pod_pribornuyu_900: {
        name: "Освещение под приборную полку, мм",
        price: 0,
        active: false,
        type: "900",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const osveshchenie_bokovoe_left = {
    osveshchenie_bokovoe__left: {
        name: "Освещение боковое",
        price: 0,
        active: false,
        type: "Слева",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const osveshchenie_bokovoe_right = {
    osveshchenie_bokovoe__right: {
        name: "Освещение боковое",
        price: 0,
        active: false,
        type: "Справа",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const perfopanel = {
    perfopanel__700x325: {
        name: "Перфопанель, мм",
        price: 0,
        active: false,
        type: "700x325",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    perfopanel__900x325: {
        name: "Перфопанель, мм",
        price: 0,
        active: false,
        type: "900x325",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    perfopanel__1200x325: {
        name: "Перфопанель, мм",
        price: 0,
        active: false,
        type: "1200x325",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    perfopanel__1500x325: {
        name: "Перфопанель, мм",
        price: 0,
        active: false,
        type: "1500x325",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    perfopanel__1800x325: {
        name: "Перфопанель, мм",
        price: 0,
        active: false,
        type: "1800x325",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    perfopanel__2000x325: {
        name: "Перфопанель, мм",
        price: 0,
        active: false,
        type: "2000x325",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    perfopanel__1200x700: {
        name: "Перфопанель, мм",
        price: 0,
        active: false,
        type: "1200x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    perfopanel__1500x700: {
        name: "Перфопанель, мм",
        price: 0,
        active: false,
        type: "1500x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    perfopanel__1800x700: {
        name: "Перфопанель, мм",
        price: 0,
        active: false,
        type: "1800x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    perfopanel__2000x700: {
        name: "Перфопанель, мм",
        price: 0,
        active: false,
        type: "2000x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const perfopanel_left = {
    perfopanel__600x325__left: {
        name: "Перфопанель половинная слева, мм",
        price: 0,
        active: false,
        type: "600x325",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    perfopanel__750x325__left: {
        name: "Перфопанель половинная слева, мм",
        price: 0,
        active: false,
        type: "750x325",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    perfopanel__900x325__left: {
        name: "Перфопанель половинная слева, мм",
        price: 0,
        active: false,
        type: "900x325",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    perfopanel__1000x325__left: {
        name: "Перфопанель половинная слева, мм",
        price: 0,
        active: false,
        type: "1000x325",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const perfopanel_right = {
    perfopanel__600x325__right: {
        name: "Перфопанель половинная справа, мм",
        price: 0,
        active: false,
        type: "600x325",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    perfopanel__750x325__right: {
        name: "Перфопанель половинная справа, мм",
        price: 0,
        active: false,
        type: "750x325",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    perfopanel__900x325__right: {
        name: "Перфопанель половинная справа, мм",
        price: 0,
        active: false,
        type: "900x325",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    perfopanel__1000x325__right: {
        name: "Перфопанель половинная справа, мм",
        price: 0,
        active: false,
        type: "1000x325",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const perfopanel__ostrov = {
    perfopanel__ostrov__1200x325: {
        name: "Перфопанель островная, мм",
        price: 0,
        active: false,
        type: "2 x (1200x325)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    perfopanel__ostrov__1500x325: {
        name: "Перфопанель островная, мм",
        price: 0,
        active: false,
        type: "2 x (1500x325)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    perfopanel__ostrov__1800x325: {
        name: "Перфопанель островная, мм",
        price: 0,
        active: false,
        type: "2 x (1800x325)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    perfopanel__ostrov__1200x700: {
        name: "Перфопанель островная, мм",
        price: 0,
        active: false,
        type: "2 x (1200x700)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    perfopanel__ostrov__1500x700: {
        name: "Перфопанель островная, мм",
        price: 0,
        active: false,
        type: "2 x (1500x700)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    perfopanel__ostrov__1800x700: {
        name: "Перфопанель островная, мм",
        price: 0,
        active: false,
        type: "2 x (1800x700)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const panel_elektromontazhnaya = {
    panel_elektromontazhnaya__700: {
        name: "Панель электромонтажная, мм",
        price: 0,
        active: false,
        type: "700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    panel_elektromontazhnaya__900: {
        name: "Панель электромонтажная, мм",
        price: 0,
        active: false,
        type: "900",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    panel_elektromontazhnaya__1200: {
        name: "Панель электромонтажная, мм",
        price: 0,
        active: false,
        type: "1200",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    panel_elektromontazhnaya__1500: {
        name: "Панель электромонтажная, мм",
        price: 0,
        active: false,
        type: "1500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    panel_elektromontazhnaya__1800: {
        name: "Панель электромонтажная, мм",
        price: 0,
        active: false,
        type: "1800",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    panel_elektromontazhnaya__2000: {
        name: "Панель электромонтажная, мм",
        price: 0,
        active: false,
        type: "2000",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const panel_elektromontazhnaya_left = {
    panel_elektromontazhnaya__600__left: {
        name: "Панель электромонтажная слева, мм",
        price: 0,
        active: false,
        type: "600",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    panel_elektromontazhnaya__750__left: {
        name: "Панель электромонтажная слева, мм",
        price: 0,
        active: false,
        type: "750",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    panel_elektromontazhnaya__900__left: {
        name: "Панель электромонтажная слева, мм",
        price: 0,
        active: false,
        type: "900",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    panel_elektromontazhnaya__1000__left: {
        name: "Панель электромонтажная слева, мм",
        price: 0,
        active: false,
        type: "1000",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const panel_elektromontazhnaya_right = {
    panel_elektromontazhnaya__600__right: {
        name: "Панель электромонтажная справа, мм",
        price: 0,
        active: false,
        type: "600",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    panel_elektromontazhnaya__750__right: {
        name: "Панель электромонтажная справа, мм",
        price: 0,
        active: false,
        type: "750",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    panel_elektromontazhnaya__900__right: {
        name: "Панель электромонтажная справа, мм",
        price: 0,
        active: false,
        type: "900",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    panel_elektromontazhnaya__1000__right: {
        name: "Панель электромонтажная справа, мм",
        price: 0,
        active: false,
        type: "1000",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const panel_elektromontazhnaya__ostrov = {
    panel_elektromontazhnaya__ostrov__1200: {
        name: "Панель электромонтажная островная, мм",
        price: 0,
        active: false,
        type: "1200",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    panel_elektromontazhnaya__ostrov__1500: {
        name: "Панель электромонтажная островная, мм",
        price: 0,
        active: false,
        type: "1500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    panel_elektromontazhnaya__ostrov__1800: {
        name: "Панель электромонтажная островная, мм",
        price: 0,
        active: false,
        type: "1800",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const rosetki_avtomati_elektropaneli_full = {
    sockets__full: {
        name: "Розетки, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up__full",
        isMultyPieces: true,
    },
    telephone_socket__full: {
        name: "Розетка телефонная RJ-45, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up__full",
        isMultyPieces: true,
    },
    computer_socket__full: {
        name: "Розетка компьютерная RJ-45, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up__full",
        isMultyPieces: true,
    },
    avtomat_odnopolyusnii_10__full: {
        name: "Автомат безопасности однополюсный ABB 10A, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up__full",
        isMultyPieces: true,
    },
    avtomat_odnopolyusnii_16__full: {
        name: "Автомат безопасности однополюсный ABB 16A, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up__full",
        isMultyPieces: true,
    },
    avtomat_dvukhpolyusnii_10__full: {
        name: "Автомат безопасности двухполюсный ABB 10A, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up__full",
        isMultyPieces: true,
    },
    avtomat_dvukhpolyusnii_16__full: {
        name: "Автомат безопасности двухполюсный ABB 16A, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up__full",
        isMultyPieces: true,
    },
    ustroistvo_otklyucheniya_16__full: {
        name: "Устройство защитного отключения ABB 16A/0,01A, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up__full",
        isMultyPieces: true,
    },
};
const rosetki_avtomati_elektropaneli_left = {
    sockets__left: {
        name: "Розетки слева, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up__half",
        isMultyPieces: true,
    },
    telephone_socket__left: {
        name: "Розетка телефонная RJ-45 слева, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up__half",
        isMultyPieces: true,
    },
    computer_socket__left: {
        name: "Розетка компьютерная RJ-45 слева, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up__half",
        isMultyPieces: true,
    },
    avtomat_odnopolyusnii_10__left: {
        name: "Автомат безопасности однополюсный ABB 10A слева, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up__half",
        isMultyPieces: true,
    },
    avtomat_odnopolyusnii_16__left: {
        name: "Автомат безопасности однополюсный ABB 16A слева, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up__half",
        isMultyPieces: true,
    },
    avtomat_dvukhpolyusnii_10__left: {
        name: "Автомат безопасности двухполюсный ABB 10A слева, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up__half",
        isMultyPieces: true,
    },
    avtomat_dvukhpolyusnii_16__left: {
        name: "Автомат безопасности двухполюсный ABB 16A слева, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up__half",
        isMultyPieces: true,
    },
    ustroistvo_otklyucheniya_16__left: {
        name: "Устройство защитного отключения ABB 16A/0,01A слева, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up__half",
        isMultyPieces: true,
    },
};
const rosetki_avtomati_elektropaneli_right = {
    sockets__right: {
        name: "Розетки справа, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up__half",
        isMultyPieces: true,
    },
    telephone_socket__right: {
        name: "Розетка телефонная RJ-45 справа, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up__half",
        isMultyPieces: true,
    },
    computer_socket__right: {
        name: "Розетка компьютерная RJ-45 справа, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up__half",
        isMultyPieces: true,
    },
    avtomat_odnopolyusnii_10__right: {
        name: "Автомат безопасности однополюсный ABB 10A справа, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up__half",
        isMultyPieces: true,
    },
    avtomat_odnopolyusnii_16__right: {
        name: "Автомат безопасности однополюсный ABB 16A справа, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up__half",
        isMultyPieces: true,
    },
    avtomat_dvukhpolyusnii_10__right: {
        name: "Автомат безопасности двухполюсный ABB 10A справа, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up__half",
        isMultyPieces: true,
    },
    avtomat_dvukhpolyusnii_16__right: {
        name: "Автомат безопасности двухполюсный ABB 16A справа, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up__half",
        isMultyPieces: true,
    },
    ustroistvo_otklyucheniya_16__right: {
        name: "Устройство защитного отключения ABB 16A/0,01A справа, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up__half",
        isMultyPieces: true,
    },
};
const lotok_metallicheskii = {
    lotok_metallicheskii__1000: {
        name: "Лоток металлический, мм",
        price: 0,
        active: false,
        type: "1000x85x75",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    lotok_metallicheskii__1200: {
        name: "Лоток металлический, мм",
        price: 0,
        active: false,
        type: "1200x85x75",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    lotok_metallicheskii__1500: {
        name: "Лоток металлический, мм",
        price: 0,
        active: false,
        type: "1500x85x75",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    lotok_metallicheskii__1800: {
        name: "Лоток металлический, мм",
        price: 0,
        active: false,
        type: "1800x85x75",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    lotok_metallicheskii__2000: {
        name: "Лоток металлический, мм",
        price: 0,
        active: false,
        type: "2000x85x75",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const lotok_metallicheskii_left = {
    lotok_metallicheskii__600__left: {
        name: "Лоток металлический половинный слева, мм",
        price: 0,
        active: false,
        type: "600x85x75",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    lotok_metallicheskii__750__left: {
        name: "Лоток металлический половинный слева, мм",
        price: 0,
        active: false,
        type: "750x85x75",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    lotok_metallicheskii__900__left: {
        name: "Лоток металлический половинный слева, мм",
        price: 0,
        active: false,
        type: "900x85x75",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    lotok_metallicheskii__1000__left: {
        name: "Лоток металлический половинный слева, мм",
        price: 0,
        active: false,
        type: "1000x85x75",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const lotok_metallicheskii_right = {
    lotok_metallicheskii__600__right: {
        name: "Лоток металлический половинный справа, мм",
        price: 0,
        active: false,
        type: "600x85x75",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    lotok_metallicheskii__750__right: {
        name: "Лоток металлический половинный справа, мм",
        price: 0,
        active: false,
        type: "750x85x75",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    lotok_metallicheskii__900__right: {
        name: "Лоток металлический половинный справа, мм",
        price: 0,
        active: false,
        type: "900x85x75",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    lotok_metallicheskii__1000__right: {
        name: "Лоток металлический половинный справа, мм",
        price: 0,
        active: false,
        type: "1000x85x75",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const planka_dlya_lotkov = {
    planka_dlya_lotkov__smk__700: {
        name: "Планка для лотков, мм",
        price: 0,
        active: false,
        type: "700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    planka_dlya_lotkov__smk__900: {
        name: "Планка для лотков, мм",
        price: 0,
        active: false,
        type: "900",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    planka_dlya_lotkov__1000: {
        name: "Планка для лотков, мм",
        price: 0,
        active: false,
        type: "1000x100",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    planka_dlya_lotkov__1200: {
        name: "Планка для лотков, мм",
        price: 0,
        active: false,
        type: "1200x100",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    planka_dlya_lotkov__1500: {
        name: "Планка для лотков, мм",
        price: 0,
        active: false,
        type: "1500x100",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    planka_dlya_lotkov__1800: {
        name: "Планка для лотков, мм",
        price: 0,
        active: false,
        type: "1800x100",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    planka_dlya_lotkov__2000: {
        name: "Планка для лотков, мм",
        price: 0,
        active: false,
        type: "2000x100",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const planka_dlya_lotkov_left = {
    planka_dlya_lotkov__600__left: {
        name: "Планка для лотков половинная слева, мм",
        price: 0,
        active: false,
        type: "600x100",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    planka_dlya_lotkov__750__left: {
        name: "Планка для лотков половинная слева, мм",
        price: 0,
        active: false,
        type: "750x100",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    planka_dlya_lotkov__900__left: {
        name: "Планка для лотков половинная слева, мм",
        price: 0,
        active: false,
        type: "900x100",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    planka_dlya_lotkov__1000__left: {
        name: "Планка для лотков половинная слева, мм",
        price: 0,
        active: false,
        type: "1000x100",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const planka_dlya_lotkov_right = {
    planka_dlya_lotkov__600__right: {
        name: "Планка для лотков половинная справа, мм",
        price: 0,
        active: false,
        type: "600x100",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    planka_dlya_lotkov__750__right: {
        name: "Планка для лотков половинная справа, мм",
        price: 0,
        active: false,
        type: "750x100",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    planka_dlya_lotkov__900__right: {
        name: "Планка для лотков половинная справа, мм",
        price: 0,
        active: false,
        type: "900x100",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    planka_dlya_lotkov__1000__right: {
        name: "Планка для лотков половинная справа, мм",
        price: 0,
        active: false,
        type: "1000x100",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const planka_dlya_lotkov__ostrov = {
    planka_dlya_lotkov__ostrov__1200: {
        name: "Планка для лотков островная, мм",
        price: 0,
        active: false,
        type: "2 x (1200x100)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    planka_dlya_lotkov__ostrov__1500: {
        name: "Планка для лотков островная, мм",
        price: 0,
        active: false,
        type: "2 x (1500x100)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    planka_dlya_lotkov__ostrov__1800: {
        name: "Планка для лотков островная, мм",
        price: 0,
        active: false,
        type: "2 x (1800x100)",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_korotkaya_left = {
    polka_korotkaya__600x300__left: {
        name: "Полка короткая слева, мм",
        price: 0,
        active: false,
        type: "600x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_korotkaya__750x300__left: {
        name: "Полка короткая слева, мм",
        price: 0,
        active: false,
        type: "750x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_korotkaya__900x300__left: {
        name: "Полка короткая слева, мм",
        price: 0,
        active: false,
        type: "900x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_korotkaya__1000x300__left: {
        name: "Полка короткая слева, мм",
        price: 0,
        active: false,
        type: "1000x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_korotkaya__600x400__left: {
        name: "Полка короткая слева, мм",
        price: 0,
        active: false,
        type: "600x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_korotkaya__750x400__left: {
        name: "Полка короткая слева, мм",
        price: 0,
        active: false,
        type: "750x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_korotkaya__900x400__left: {
        name: "Полка короткая слева, мм",
        price: 0,
        active: false,
        type: "900x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_korotkaya__1000x400__left: {
        name: "Полка короткая слева, мм",
        price: 0,
        active: false,
        type: "1000x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_korotkaya_right = {
    polka_korotkaya__600x300__right: {
        name: "Полка короткая справа, мм",
        price: 0,
        active: false,
        type: "600x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_korotkaya__750x300__right: {
        name: "Полка короткая справа, мм",
        price: 0,
        active: false,
        type: "750x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_korotkaya__900x300__right: {
        name: "Полка короткая справа, мм",
        price: 0,
        active: false,
        type: "900x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_korotkaya__1000x300__right: {
        name: "Полка короткая справа, мм",
        price: 0,
        active: false,
        type: "1000x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_korotkaya__600x400__right: {
        name: "Полка короткая справа, мм",
        price: 0,
        active: false,
        type: "600x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_korotkaya__750x400__right: {
        name: "Полка короткая справа, мм",
        price: 0,
        active: false,
        type: "750x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_korotkaya__900x400__right: {
        name: "Полка короткая справа, мм",
        price: 0,
        active: false,
        type: "900x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_korotkaya__1000x400__right: {
        name: "Полка короткая справа, мм",
        price: 0,
        active: false,
        type: "1000x400",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_naklonnaya_left = {
    polka_naklonnaya__600x300__left: {
        name: "Полка наклонная слева, мм",
        price: 0,
        active: false,
        type: "600x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_naklonnaya__750x300__left: {
        name: "Полка наклонная слева, мм",
        price: 0,
        active: false,
        type: "750x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_naklonnaya__900x300__left: {
        name: "Полка наклонная слева, мм",
        price: 0,
        active: false,
        type: "900x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_naklonnaya__1000x300__left: {
        name: "Полка наклонная слева, мм",
        price: 0,
        active: false,
        type: "1000x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_naklonnaya_right = {
    polka_naklonnaya__600x300__right: {
        name: "Полка наклонная справа, мм",
        price: 0,
        active: false,
        type: "600x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_naklonnaya__750x300__right: {
        name: "Полка наклонная справа, мм",
        price: 0,
        active: false,
        type: "750x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_naklonnaya__900x300__right: {
        name: "Полка наклонная справа, мм",
        price: 0,
        active: false,
        type: "900x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    polka_naklonnaya__1000x300__right: {
        name: "Полка наклонная справа, мм",
        price: 0,
        active: false,
        type: "1000x300",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const derzhatel_monitora_left = {
    derzhatel_monitora_1__left: {
        name: "Держатель монитора, к-во рычагов",
        price: 0,
        active: false,
        type: "1",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_monitora_2__left: {
        name: "Держатель монитора, к-во рычагов",
        price: 0,
        active: false,
        type: "2",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_monitora_3__left: {
        name: "Держатель монитора, к-во рычагов",
        price: 0,
        active: false,
        type: "3",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const derzhatel_monitora_right = {
    derzhatel_monitora_1__right: {
        name: "Держатель монитора, к-во рычагов",
        price: 0,
        active: false,
        type: "1",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_monitora_2__right: {
        name: "Держатель монитора, к-во рычагов",
        price: 0,
        active: false,
        type: "2",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_monitora_3__right: {
        name: "Держатель монитора, к-во рычагов",
        price: 0,
        active: false,
        type: "3",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const elektropanel = {
    elektropanel__6: {
        name: "Электропанель, к-во розеток",
        price: 0,
        active: false,
        type: "6",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    elektropanel__8: {
        name: "Электропанель, к-во розеток",
        price: 0,
        active: false,
        type: "8",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    elektropanel__12: {
        name: "Электропанель, к-во розеток",
        price: 0,
        active: false,
        type: "12",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_dlya_klaviaturi_i_mishi_left = {
    polka_dlya_klaviaturi_i_mishi__left: {
        name: "Полка для клавиатуры и мыши, слева, шт.",
        price: 0,
        active: false,
        type: "1",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const polka_dlya_klaviaturi_i_mishi_right = {
    polka_dlya_klaviaturi_i_mishi__right: {
        name: "Полка для клавиатуры и мыши, справа, шт.",
        price: 0,
        active: false,
        type: "1",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const kronshtein_dlya_printera_left = {
    kronshtein_dlya_printera__left: {
        name: "Кронштейн для принтера, слева, шт.",
        price: 0,
        active: false,
        type: "1",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const kronshtein_dlya_printera_right = {
    kronshtein_dlya_printera__right: {
        name: "Кронштейн для принтера, справа, шт.",
        price: 0,
        active: false,
        type: "1",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const podstavka_dlya_chertezhei_left = {
    podstavka_dlya_chertezhei__left: {
        name: "Подставка для чертежей, слева, шт.",
        price: 0,
        active: false,
        type: "1",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const podstavka_dlya_chertezhei_right = {
    podstavka_dlya_chertezhei__right: {
        name: "Подставка для чертежей, справа, шт.",
        price: 0,
        active: false,
        type: "1",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const acssesuari_dlya_perfopaneli = {
    kryuchok_na_perfopanel__1: {
        name: "Держатель отвёрток, шт.",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up",
        isMultyPieces: true,
    },
    kryuchok_na_perfopanel__2: {
        name: "Держатель мелких инструментов, шт.",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up",
        isMultyPieces: true,
    },
    kryuchok_na_perfopanel__3: {
        name: "Держатель инструмента, шт.",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up",
        isMultyPieces: true,
    },
    kryuchok_na_perfopanel__4: {
        name: "Держатель ключей, шт.",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up",
        isMultyPieces: true,
    },
    kryuchok_na_perfopanel__5: {
        name: "Держатель молотка, шт.",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up",
        isMultyPieces: true,
    },
    kryuchok_na_perfopanel__6: {
        name: "Лоток мелких элементов, шт.",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up",
        isMultyPieces: true,
    },
    kryuchok_na_perfopanel__7: {
        name: "Держатель папок, шт.",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up",
        isMultyPieces: true,
    },
    kryuchok_na_perfopanel__8: {
        name: "Лоток для мелочей, шт.",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up",
        isMultyPieces: true,
    },
    kryuchok_na_perfopanel__9: {
        name: "Держатель отвёрток, шт.",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up",
        isMultyPieces: true,
    },
    kryuchok_na_perfopanel__10: {
        name: "Держатель мелких инструментов, шт.",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up",
        isMultyPieces: true,
    },
    kryuchok_na_perfopanel__11: {
        name: "Держатель скотча, шт.",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up",
        isMultyPieces: true,
    },
    kryuchok_na_perfopanel__12: {
        name: "Держатель папок, шт.",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        position: "up",
        isMultyPieces: true,
    },
};
const fiksator_rulonnikh_materialov__half_width__right = {
    fiksator_rulonnikh_materialov__half_width__600__right: {
        name: "Фиксатор рулонных материалов половинный справа, мм",
        price: 0,
        active: false,
        type: "600",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    fiksator_rulonnikh_materialov__half_width__750__right: {
        name: "Фиксатор рулонных материалов половинный справа, мм",
        price: 0,
        active: false,
        type: "750",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    fiksator_rulonnikh_materialov__half_width__900__right: {
        name: "Фиксатор рулонных материалов половинный справа, мм",
        price: 0,
        active: false,
        type: "900",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    fiksator_rulonnikh_materialov__half_width__1000__right: {
        name: "Фиксатор рулонных материалов половинный справа, мм",
        price: 0,
        active: false,
        type: "1000",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const fiksator_rulonnikh_materialov__half_width__left = {
    fiksator_rulonnikh_materialov__half_width__600__left: {
        name: "Фиксатор рулонных материалов половинный слева, мм",
        price: 0,
        active: false,
        type: "600",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    fiksator_rulonnikh_materialov__half_width__750__left: {
        name: "Фиксатор рулонных материалов половинный слева, мм",
        price: 0,
        active: false,
        type: "750",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    fiksator_rulonnikh_materialov__half_width__900__left: {
        name: "Фиксатор рулонных материалов половинный слева, мм",
        price: 0,
        active: false,
        type: "900",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    fiksator_rulonnikh_materialov__half_width__1000__left: {
        name: "Фиксатор рулонных материалов половинный слева, мм",
        price: 0,
        active: false,
        type: "1000",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const fiksator_rulonnikh_materialov__full_width = {
    fiksator_rulonnikh_materialov__full_width__1200: {
        name: "Фиксатор рулонных материалов, мм",
        price: 0,
        active: false,
        type: "1200",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    fiksator_rulonnikh_materialov__full_width__1500: {
        name: "Фиксатор рулонных материалов, мм",
        price: 0,
        active: false,
        type: "1500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    fiksator_rulonnikh_materialov__full_width__1800: {
        name: "Фиксатор рулонных материалов, мм",
        price: 0,
        active: false,
        type: "1800",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    fiksator_rulonnikh_materialov__full_width__2000: {
        name: "Фиксатор рулонных материалов, мм",
        price: 0,
        active: false,
        type: "2000",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const rezak_rulonnikh_materialov = {
    rezak_rulonnikh_materialov__600: {
        name: "Резак рулонных материалов, мм",
        price: 0,
        active: false,
        type: "590х130х155",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    rezak_rulonnikh_materialov__750: {
        name: "Резак рулонных материалов, мм",
        price: 0,
        active: false,
        type: "740х130х155",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    rezak_rulonnikh_materialov__1000: {
        name: "Резак рулонных материалов, мм",
        price: 0,
        active: false,
        type: "990х130х155",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    rezak_rulonnikh_materialov__1200: {
        name: "Резак рулонных материалов, мм",
        price: 0,
        active: false,
        type: "1190х130х155",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    rezak_rulonnikh_materialov__1500: {
        name: "Резак рулонных материалов, мм",
        price: 0,
        active: false,
        type: "1490х130х155",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    rezak_rulonnikh_materialov__1800: {
        name: "Резак рулонных материалов, мм",
        price: 0,
        active: false,
        type: "1790х130х155",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    rezak_rulonnikh_materialov__2000: {
        name: "Резак рулонных материалов, мм",
        price: 0,
        active: false,
        type: "1990х130х155",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const derzhatel_rulona_bokovoi__left = {
    derzhatel_rulona_bokovoi__700__left: {
        name: "Держатель рулона боковой слева, мм",
        price: 0,
        active: false,
        type: "700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona_bokovoi__900__left: {
        name: "Держатель рулона боковой слева, мм",
        price: 0,
        active: false,
        type: "900",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const derzhatel_rulona_bokovoi__right = {
    derzhatel_rulona_bokovoi__700__right: {
        name: "Держатель рулона боковой справа, мм",
        price: 0,
        active: false,
        type: "700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona_bokovoi__900__right: {
        name: "Держатель рулона боковой справа, мм",
        price: 0,
        active: false,
        type: "900",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const derzhatel_rulona__half_width__left = {
    derzhatel_rulona_verkhnii__600__left: {
        name: "Держатель рулона половинный слева, мм",
        price: 0,
        active: false,
        type: "600",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona_verkhnii__750__left: {
        name: "Держатель рулона половинный слева, мм",
        price: 0,
        active: false,
        type: "750",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona_verkhnii__900__left: {
        name: "Держатель рулона половинный слева, мм",
        price: 0,
        active: false,
        type: "900",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona_verkhnii__1000__left: {
        name: "Держатель рулона половинный слева, мм",
        price: 0,
        active: false,
        type: "1000",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const derzhatel_rulona__half_width__right = {
    derzhatel_rulona_verkhnii__600__right: {
        name: "Держатель рулона половинный справа, мм",
        price: 0,
        active: false,
        type: "600",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona_verkhnii__750__right: {
        name: "Держатель рулона половинный справа, мм",
        price: 0,
        active: false,
        type: "750",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona_verkhnii__900__right: {
        name: "Держатель рулона половинный справа, мм",
        price: 0,
        active: false,
        type: "900",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona_verkhnii__1000__right: {
        name: "Держатель рулона половинный справа, мм",
        price: 0,
        active: false,
        type: "1000",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const derzhatel_rulona__full_width__1 = {
    derzhatel_rulona_verkhnii__1200__1: {
        name: "Держатель рулона во всю ширину, мм",
        price: 0,
        active: false,
        type: "1200",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona_verkhnii__1500__1: {
        name: "Держатель рулона во всю ширину, мм",
        price: 0,
        active: false,
        type: "1500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona_verkhnii__1800__1: {
        name: "Держатель рулона во всю ширину, мм",
        price: 0,
        active: false,
        type: "1800",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona_verkhnii__2000__1: {
        name: "Держатель рулона во всю ширину, мм",
        price: 0,
        active: false,
        type: "2000",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const derzhatel_rulona__full_width__2 = {
    derzhatel_rulona_verkhnii__1200__2: {
        name: "Держатель рулона во всю ширину, мм",
        price: 0,
        active: false,
        type: "1200",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona_verkhnii__1500__2: {
        name: "Держатель рулона во всю ширину, мм",
        price: 0,
        active: false,
        type: "1500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona_verkhnii__1800__2: {
        name: "Держатель рулона во всю ширину, мм",
        price: 0,
        active: false,
        type: "1800",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona_verkhnii__2000__2: {
        name: "Держатель рулона во всю ширину, мм",
        price: 0,
        active: false,
        type: "2000",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const derzhatel_rulona__full_width__3 = {
    derzhatel_rulona_verkhnii__1200__3: {
        name: "Держатель рулона во всю ширину, мм",
        price: 0,
        active: false,
        type: "1200",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona_verkhnii__1500__3: {
        name: "Держатель рулона во всю ширину, мм",
        price: 0,
        active: false,
        type: "1500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona_verkhnii__1800__3: {
        name: "Держатель рулона во всю ширину, мм",
        price: 0,
        active: false,
        type: "1800",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona_verkhnii__2000__3: {
        name: "Держатель рулона во всю ширину, мм",
        price: 0,
        active: false,
        type: "2000",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const derzhatel_rulona__full_width__4 = {
    derzhatel_rulona_verkhnii__1200__4: {
        name: "Держатель рулона во всю ширину, мм",
        price: 0,
        active: false,
        type: "1200",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona_verkhnii__1500__4: {
        name: "Держатель рулона во всю ширину, мм",
        price: 0,
        active: false,
        type: "1500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona_verkhnii__1800__4: {
        name: "Держатель рулона во всю ширину, мм",
        price: 0,
        active: false,
        type: "1800",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona_verkhnii__2000__4: {
        name: "Держатель рулона во всю ширину, мм",
        price: 0,
        active: false,
        type: "2000",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
const derzhatel_rulona__full_width__5 = {
    derzhatel_rulona_verkhnii__1200__5: {
        name: "Держатель рулона во всю ширину, мм",
        price: 0,
        active: false,
        type: "1200",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona_verkhnii__1500__5: {
        name: "Держатель рулона во всю ширину, мм",
        price: 0,
        active: false,
        type: "1500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona_verkhnii__1800__5: {
        name: "Держатель рулона во всю ширину, мм",
        price: 0,
        active: false,
        type: "1800",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    derzhatel_rulona_verkhnii__2000__5: {
        name: "Держатель рулона во всю ширину, мм",
        price: 0,
        active: false,
        type: "2000",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};

function addGroup(obj, groupName, position = null) {
    Object.keys(obj).forEach((key) => {
        obj[key].group = groupName;
        if (position !== null) {
            obj[key].position = position;
        }
    });
}

// Проставляем группы
// TABLES
addGroup(stol_basovii, "stol_basovii", "table");
addGroup(stol_komfort, "stol_komfort", "table");
addGroup(stol_spr, "stol_spr", "table");
addGroup(stol_spb, "stol_spb", "table");
addGroup(stol_ostrov, "stol_ostrov", "table");
addGroup(stol_verstak_tumba, "stol_verstak_tumba", "table");
addGroup(stol_verstak_2_tumba, "stol_verstak_tumba", "table");
addGroup(verstak__vs__tumba, "verstak_tumba", "table");
addGroup(verstak__vs__2_tumba, "verstak_tumba", "table");
addGroup(stol_upakovochnii, "stol_upakovochnii", "table");
addGroup(stol_ksm, "stol_ksm", "table");
addGroup(stol_raskroinii, "stol_raskroinii", "table");
addGroup(stol_ssu, "stol_ssu", "table");
addGroup(stol_smk, "stol_smk", "table");
addGroup(stoyki, "stol_raskroinii", "table");
addGroup(telezhki, "telezhki", "table");
addGroup(tumbi, "tumbi", "table");
addGroup(stoli_podkatnie, "stol_podkatnoi", "table");
addGroup(telezhki, "stol_raskroinii", "table");
addGroup(stellazhi, "stellazhi", "table");
addGroup(stulya, "stulya", "table");
addGroup(wardrobes, "wardrobes", "table");

addGroup(dop_pokritie, "dop_pokritie", "base");
addGroup(dop_pokritie_verstak, "dop_pokritie_verstak", "base");
addGroup(dop_pokritie__ostrov, "dop_pokritie__ostrov", "base");
addGroup(table_stops_zadnii, "table_stops_zadnii", "base");
addGroup(table_stops_zadnii__ostrov, "table_stops_zadnii__ostrov", "base");
addGroup(table_stops_bokovoi, "table_stops_bokovoi", "base");
addGroup(table_stops_bokovoi__ostrov, "table_stops_bokovoi__ostrov", "base");
addGroup(corner_table, "corner_table", "base");
addGroup(tumba_podvesnaya_left, "tumba_podvesnaya_left", "down");
addGroup(tumba_podvesnaya_right, "tumba_podvesnaya_right", "down");
addGroup(annex_left_up, "annex_left_up", "down");
addGroup(annex_right_up, "annex_right_up", "down");
addGroup(annex_left_down, "annex_left_down", "down");
addGroup(annex_right_down, "annex_right_down", "down");
addGroup(polka_nizhnyaya, "polka_nizhnyaya", "down");
addGroup(polka_nizhnyaya__ostrov, "polka_nizhnyaya__ostrov", "down");
addGroup(lotok_dlya_provodov, "lotok_dlya_provodov", "down");
addGroup(podstavka_pod_sistemnii_blok, "podstavka_pod_sistemnii_blok", "down");
addGroup(polka_dlya_klaviaturi, "polka_dlya_klaviaturi", "down");
addGroup(polka_dlya_kantselyarskikh_prinadlezhnostei, "polka_dlya_kantselyarskikh_prinadlezhnostei", "down");
addGroup(polka_vidvizhnaya_pod_orgtekhniku, "polka_vidvizhnaya_pod_orgtekhniku", "down");
addGroup(konteiner_dlya_rabochikh_otkhodov, "konteiner_dlya_rabochikh_otkhodov", "down");
addGroup(podstavka_pod_nogi, "podstavka_pod_nogi", "down");
addGroup(yashchik_mk_plastik, "yashchik_mk_plastik", "down");
addGroup(yashchik_mk_metall, "yashchik_mk_metall", "down");
addGroup(bokovie_fiksatori_rulona__nizhnii, null, "down");
addGroup(derzhatel_rulona__nizhnii, derzhatel_rulona__nizhnii, "down");

addGroup(osveshchenie_bokovoe_left, "osveshchenie_bokovoe_left", "up");
addGroup(osveshchenie_bokovoe_right, "osveshchenie_bokovoe_right", "up");
addGroup(bokovie_fiksatori_rulona__verkhnii, null, "up");

addGroup(perfopanel, "perfopanel", "up__full");
addGroup(perfopanel_verstak, "perfopanel_verstak", "up__full");
addGroup(perfopanel__ostrov, "perfopanel", "up__full");
addGroup(panel_elektromontazhnaya, "panel_elektromontazhnaya", "up__full");
addGroup(panel_elektromontazhnaya__ostrov, "panel_elektromontazhnaya__ostrov", "up__full");
addGroup(lotok_metallicheskii, "lotok_metallicheskii", "up__full");
addGroup(planka_dlya_lotkov, "planka_dlya_lotkov", "up__full");
addGroup(planka_dlya_lotkov__ostrov, "planka_dlya_lotkov__ostrov", "up__full");
addGroup(planka_dlya_lotkov_plv, "planka_dlya_lotkov__ostrov", "up__full");
addGroup(bokovie_fiksatori_rulona__full_width, null, "up__full");
addGroup(fiksator_rulonnikh_materialov__full_width, "fiksator_rulonnikh_materialov__full_width", "up__full");
addGroup(derzhatel_rulona__full_width__1, "derzhatel_rulona__full_width__1", "up__full");
addGroup(derzhatel_rulona__full_width__2, "derzhatel_rulona__full_width__2", "up__full");
addGroup(derzhatel_rulona__full_width__3, "derzhatel_rulona__full_width__3", "up__full");
addGroup(derzhatel_rulona__full_width__4, "derzhatel_rulona__full_width__4", "up__full");
addGroup(derzhatel_rulona__full_width__5, "derzhatel_rulona__full_width__5", "up__full");

addGroup(perfopanel_left, "perfopanel_left", "up__half");
addGroup(perfopanel_right, "perfopanel_right", "up__half");
addGroup(panel_elektromontazhnaya_left, "panel_elektromontazhnaya_left", "up__half");
addGroup(panel_elektromontazhnaya_right, "panel_elektromontazhnaya_right", "up__half");
addGroup(lotok_metallicheskii_left, "lotok_metallicheskii_left", "up__half");
addGroup(lotok_metallicheskii_right, "lotok_metallicheskii_right", "up__half");
addGroup(planka_dlya_lotkov_left, "planka_dlya_lotkov_left", "up__half");
addGroup(planka_dlya_lotkov_right, "planka_dlya_lotkov_right", "up__half");
addGroup(polka_korotkaya_left, "polka_korotkaya_left", "up__half");
addGroup(polka_korotkaya_right, "polka_korotkaya_right", "up__half");
addGroup(polka_naklonnaya_left, "polka_naklonnaya_left", "up__half");
addGroup(polka_naklonnaya_right, "polka_naklonnaya_right", "up__half");
addGroup(bokovie_fiksatori_rulona__half_width, null, "up__half");
addGroup(derzhatel_rulona__half_width__left, derzhatel_rulona__half_width__left, "up__half");
addGroup(derzhatel_rulona__half_width__right, derzhatel_rulona__half_width__right, "up__half");
addGroup(
    fiksator_rulonnikh_materialov__half_width__right,
    "fiksator_rulonnikh_materialov__half_width__right",
    "up__half",
);
addGroup(
    fiksator_rulonnikh_materialov__half_width__left,
    "fiksator_rulonnikh_materialov__half_width__left",
    "up__half",
);

addGroup(rama_razdelitelnaya, "rama_razdelitelnaya", "up");
addGroup(derzhatel_monitora_left, "derzhatel_monitora_left", "up");
addGroup(derzhatel_monitora_right, "derzhatel_monitora_right", "up");
addGroup(elektropanel, "elektropanel", "up");
addGroup(polka_dlya_klaviaturi_i_mishi_left, "polka_dlya_klaviaturi_i_mishi_left", "up");
addGroup(polka_dlya_klaviaturi_i_mishi_right, "polka_dlya_klaviaturi_i_mishi_right", "up");
addGroup(kronshtein_dlya_printera_left, "kronshtein_dlya_printera_left", "up");
addGroup(kronshtein_dlya_printera_right, "kronshtein_dlya_printera_right", "up");
addGroup(podstavka_dlya_chertezhei_left, "podstavka_dlya_chertezhei_left", "up");
addGroup(podstavka_dlya_chertezhei_right, "podstavka_dlya_chertezhei_right", "up");
addGroup(polka_pribornaya_dsp_1, "polka_pribornaya_dsp_1", "up");
addGroup(polka_pribornaya_dsp_2, "polka_pribornaya_dsp_2", "up");
addGroup(polka_pribornaya_dsp_3, "polka_pribornaya_dsp_3", "up");
addGroup(polka_pribornaya_ostrov_1, "polka_pribornaya_ostrov_1", "up");
addGroup(polka_pribornaya_ostrov_2, "polka_pribornaya_ostrov_2", "up");
addGroup(polka_pribornaya_ostrov_3, "polka_pribornaya_ostrov_3", "up");
addGroup(polka_pribornaya_ogranichiteli_zad_1, "polka_pribornaya_ogranichiteli_zad_1", "up");
addGroup(polka_pribornaya_ogranichiteli_zad_2, "polka_pribornaya_ogranichiteli_zad_2", "up");
addGroup(polka_pribornaya_ogranichiteli_zad_3, "polka_pribornaya_ogranichiteli_zad_3", "up");
addGroup(polka_pribornaya_ogranichiteli_zad_4, "polka_pribornaya_ogranichiteli_zad_4", "up");
addGroup(polka_pribornaya_ogranichiteli_zad_5, "polka_pribornaya_ogranichiteli_zad_5", "up");
addGroup(polka_pribornaya_ogranichiteli_zad_ostrov_1, "polka_pribornaya_ogranichiteli_zad_ostrov_1", "up");
addGroup(polka_pribornaya_ogranichiteli_zad_ostrov_2, "polka_pribornaya_ogranichiteli_zad_ostrov_2", "up");
addGroup(polka_pribornaya_ogranichiteli_zad_ostrov_3, "polka_pribornaya_ogranichiteli_zad_ostrov_3", "up");
addGroup(polka_pribornaya_ogranichiteli_bok_1, "polka_pribornaya_ogranichiteli_bok_1", "up");
addGroup(polka_pribornaya_ogranichiteli_bok_2, "polka_pribornaya_ogranichiteli_bok_2", "up");
addGroup(polka_pribornaya_ogranichiteli_bok_3, "polka_pribornaya_ogranichiteli_bok_3", "up");
addGroup(polka_pribornaya_ogranichiteli_bok_4, "polka_pribornaya_ogranichiteli_bok_4", "up");
addGroup(polka_pribornaya_ogranichiteli_bok_5, "polka_pribornaya_ogranichiteli_bok_5", "up");
addGroup(zink__stoyka, "zink__stoyka", "up");
addGroup(zink_stoli_podkatnie, "zink_stoli_podkatnie", "up");
addGroup(polka_pribornaya_ogranichiteli_bok_ostrov_1, "polka_pribornaya_ogranichiteli_bok_ostrov_1", "up");
addGroup(polka_pribornaya_ogranichiteli_bok_ostrov_2, "polka_pribornaya_ogranichiteli_bok_ostrov_2", "up");
addGroup(polka_pribornaya_ogranichiteli_bok_ostrov_3, "polka_pribornaya_ogranichiteli_bok_ostrov_3", "up");
addGroup(polka_pribornaya_metall_1, "polka_pribornaya_metall_1", "up");
addGroup(polka_pribornaya_metall_2, "polka_pribornaya_metall_2", "up");
addGroup(polka_pribornaya_metall_3, "polka_pribornaya_metall_3", "up");
addGroup(osveshchenie_verkhnee, "osveshchenie_verkhnee", "up");
addGroup(osveshchenie_verkhnee_ostrov, "osveshchenie_verkhnee_ostrov", "up");
addGroup(instrumentalnaya_planka, "instrumentalnaya_planka", "up");
addGroup(instrumentalnaya_planka_ostrov, "instrumentalnaya_planka_ostrov", "up");
addGroup(osveshchenie_pod_pribornuyu, "osveshchenie_pod_pribornuyu", "up");
addGroup(rezak_rulonnikh_materialov, "rezak_rulonnikh_materialov", "up");
addGroup(derzhatel_rulona_bokovoi__left, "derzhatel_rulona_bokovoi__left", "up");
addGroup(derzhatel_rulona_bokovoi__right, "derzhatel_rulona_bokovoi__right", "up");
addGroup(dop_polka_pfk, "dop_polka_pfk", "up");
addGroup(derzhatel_rulona__stoyka__1, "derzhatel_rulona__stoyka__1", "up");
addGroup(derzhatel_rulona__stoyka__2, "derzhatel_rulona__stoyka__2", "up");
addGroup(derzhatel_rulona__stoyka__3, "derzhatel_rulona__stoyka__3", "up");
addGroup(derzhatel_rulona__stoyka__4, "derzhatel_rulona__stoyka__4", "up");
addGroup(ogranichitel__stoyka__zad, "ogranichitel__stoyka__zad", "up");
addGroup(ogranichitel__stoyka__bok, "ogranichitel__stoyka__bok", "up");

addGroup(ruchkaSyomnaya, "ruchkaSyomnaya", "up");

addGroup(dop_polka__telezhka__1, "dop_polka__telezhka__1", "base");
addGroup(dop_polka__telezhka__2, "dop_polka__telezhka__2", "base");

addGroup(krishka_na_tumbu, "krishka_na_tumbu", "base");
addGroup(podstavka_pmt, "podstavka_pmt", "base");

addGroup(polka__stellazhi, "polka__stellazhi", "base");

addGroup(gazlift, "gazlift", "base");
addGroup(koltso_opornoe, "koltso_opornoe", "base");
addGroup(podlokotniki__esd, "podlokotniki__esd", "base");
addGroup(glaydery__esd, "glaydery__esd", "base");

addGroup(polka__wardrobes, "polka__wardrobes", "base");

export const elementItems = {
    ...stol_basovii,
    ...stol_komfort,
    ...stol_spr,
    ...stol_spb,
    ...stol_ostrov,
    ...stol_verstak_tumba,
    ...stol_verstak_2_tumba,
    ...verstak__vs__tumba,
    ...verstak__vs__2_tumba,
    ...stol_upakovochnii,
    ...stol_ksm,
    ...stol_raskroinii,
    ...stol_ssu,
    ...stol_smk,

    ...elements,
    ...dop_pokritie,
    ...dop_pokritie_verstak,
    ...dop_pokritie__ostrov,
    ...table_stops_zadnii,
    ...table_stops_zadnii__ostrov,
    ...table_stops_bokovoi,
    ...table_stops_bokovoi__ostrov,
    ...corner_table,
    // Нижние
    ...polka_nizhnyaya,
    ...polka_nizhnyaya__ostrov,
    ...annex_left_up,
    ...annex_left_down,
    ...annex_right_up,
    ...annex_right_down,
    ...tumba_podvesnaya_left,
    ...tumba_podvesnaya_right,
    ...acssesuari_dlya_tumbi,
    ...razdeliteli,
    ...bokovie_fiksatori_rulona__nizhnii,
    ...derzhatel_rulona__nizhnii,

    ...podstavka_pod_sistemnii_blok,
    ...polka_dlya_klaviaturi,
    ...polka_dlya_kantselyarskikh_prinadlezhnostei,
    ...polka_vidvizhnaya_pod_orgtekhniku,
    ...konteiner_dlya_rabochikh_otkhodov,
    ...lotok_dlya_provodov,
    ...podstavka_pod_nogi,

    // Верхние
    ...rama_razdelitelnaya,
    ...polka_pribornaya_dsp_1,
    ...polka_pribornaya_dsp_2,
    ...polka_pribornaya_dsp_3,
    ...polka_pribornaya_ostrov_1,
    ...polka_pribornaya_ostrov_2,
    ...polka_pribornaya_ostrov_3,
    ...polka_pribornaya_ogranichiteli_zad_1,
    ...polka_pribornaya_ogranichiteli_zad_2,
    ...polka_pribornaya_ogranichiteli_zad_3,
    ...polka_pribornaya_ogranichiteli_zad_4,
    ...polka_pribornaya_ogranichiteli_zad_5,
    ...polka_pribornaya_ogranichiteli_zad_ostrov_1,
    ...polka_pribornaya_ogranichiteli_zad_ostrov_2,
    ...polka_pribornaya_ogranichiteli_zad_ostrov_3,
    ...polka_pribornaya_ogranichiteli_bok_1,
    ...polka_pribornaya_ogranichiteli_bok_2,
    ...polka_pribornaya_ogranichiteli_bok_3,
    ...polka_pribornaya_ogranichiteli_bok_4,
    ...polka_pribornaya_ogranichiteli_bok_5,
    ...polka_pribornaya_ogranichiteli_bok_ostrov_1,
    ...polka_pribornaya_ogranichiteli_bok_ostrov_2,
    ...polka_pribornaya_ogranichiteli_bok_ostrov_3,
    ...polka_pribornaya_metall_1,
    ...polka_pribornaya_metall_2,
    ...polka_pribornaya_metall_3,
    ...osveshchenie_verkhnee,
    ...osveshchenie_verkhnee_ostrov,
    ...instrumentalnaya_planka,
    ...instrumentalnaya_planka_ostrov,
    ...derzhatel_ruchnogo_instrumenta,
    ...osveshchenie_pod_pribornuyu,
    ...osveshchenie_bokovoe_left,
    ...osveshchenie_bokovoe_right,
    ...bokovie_fiksatori_rulona__verkhnii,
    ...razdeliteli_pribornaya,
    ...rezak_rulonnikh_materialov,
    ...derzhatel_rulona_bokovoi__left,
    ...derzhatel_rulona_bokovoi__right,

    // Во всю ширину
    ...perfopanel,
    ...perfopanel_verstak,
    ...perfopanel__ostrov,
    ...panel_elektromontazhnaya,
    ...panel_elektromontazhnaya__ostrov,
    ...rosetki_avtomati_elektropaneli_full,
    ...lotok_metallicheskii,
    ...planka_dlya_lotkov,
    ...planka_dlya_lotkov_plv,
    ...planka_dlya_lotkov__ostrov,
    ...bokovie_fiksatori_rulona__full_width,
    ...fiksator_rulonnikh_materialov__full_width,
    ...derzhatel_rulona__full_width__1,
    ...derzhatel_rulona__full_width__2,
    ...derzhatel_rulona__full_width__3,
    ...derzhatel_rulona__full_width__4,
    ...derzhatel_rulona__full_width__5,

    // Половинные
    ...perfopanel_left,
    ...perfopanel_right,
    ...panel_elektromontazhnaya_left,
    ...rosetki_avtomati_elektropaneli_left,
    ...panel_elektromontazhnaya_right,
    ...rosetki_avtomati_elektropaneli_right,
    ...lotok_metallicheskii_left,
    ...lotok_metallicheskii_right,
    ...planka_dlya_lotkov_left,
    ...planka_dlya_lotkov_right,
    ...polka_korotkaya_left,
    ...polka_korotkaya_right,
    ...polka_naklonnaya_left,
    ...polka_naklonnaya_right,
    ...bokovie_fiksatori_rulona__half_width,
    ...fiksator_rulonnikh_materialov__half_width__left,
    ...fiksator_rulonnikh_materialov__half_width__right,
    ...derzhatel_rulona__half_width__left,
    ...derzhatel_rulona__half_width__right,

    // Аксессуары
    ...derzhatel_monitora_left,
    ...derzhatel_monitora_right,
    ...elektropanel,
    ...polka_dlya_klaviaturi_i_mishi_left,
    ...polka_dlya_klaviaturi_i_mishi_right,
    ...yashchik_mk_plastik,
    ...yashchik_mk_metall,
    ...kronshtein_dlya_printera_left,
    ...kronshtein_dlya_printera_right,
    ...podstavka_dlya_chertezhei_left,
    ...podstavka_dlya_chertezhei_right,
    ...acssesuari_dlya_perfopaneli,

    // СТОЙКИ
    ...stoyki,
    ...zink__stoyka,
    ...dop_polka_pfk,
    ...derzhatel_rulona__stoyka__1,
    ...derzhatel_rulona__stoyka__2,
    ...derzhatel_rulona__stoyka__3,
    ...derzhatel_rulona__stoyka__4,
    ...ogranichitel__stoyka__zad,
    ...ogranichitel__stoyka__bok,

    // СТОЛЫ ПОДКАТНЫЕ
    ...stoli_podkatnie,
    ...zink_stoli_podkatnie,
    ...ruchkaSyomnaya,

    // ТЕЛЕЖКИ
    ...telezhki,
    ...dop_polka__telezhka__1,
    ...dop_polka__telezhka__2,

    // ТУМБЫ
    ...tumbi,
    ...krishka_na_tumbu,
    ...podstavka_pmt,

    // СТЕЛЛАЖИ
    ...stellazhi,
    ...polka__stellazhi,

    // СТУЛЬЯ
    ...stulya,
    ...gazlift,
    ...koltso_opornoe,
    ...podlokotniki__esd,
    ...glaydery__esd,

    // ШКАФЫ
    ...wardrobes,
    ...polka__wardrobes,
};
